import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import StatusModal  from './StatusModal';
import { useTranslation } from 'react-i18next';
import StatusHistoryModal  from './StatusHistoryModal';
import UniversalLookup from './UniversalLookup';
import ClassificationTree from './ClassificationTree';
import AttachmentsModal from './AttachmentsModal';
import AssetPreviewCard from './AssetPreviewCard';
import { useFontSize } from './FontSizeContext';
import SmartPrintButton from './PrintButton'; 
import WorkflowActionModal from './WorkflowActionModal';
import WorkflowHistoryModal from './WorkflowHistoryModal';
import { usePermissions } from './usePermissions';
import { 
  Save, Search, Briefcase, Plus, ShieldAlert, Activity, FileText, Clock,  
  History, Trash2, ArrowLeft, Zap, List, DollarSign, Tool, UserCheck, AlertTriangle, Tag, Paperclip, Calendar, ChevronLeft, ChevronRight, CheckCircle, Type, Minus, Printer, BrainCircuit, Filter, Workflow   
} from 'lucide-react';

const WorkOrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar' || i18n.language === 'ur';
  const [fieldMaps, setFieldMaps] = useState({});
  const isNew = !id || id === 'new';
  const [activeTab, setActiveTab] = useState('Work Order');
  const [planSubTab, setPlanSubTab] = useState('Tasks');
  const [actualSubTab, setActualSubTab] = useState('Labor');
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [isDocModalOpen, setIsDocModalOpen] = useState(false);
  const [isWFHistoryOpen, setIsWFHistoryOpen] = useState(false);
  const [hoveredAsset, setHoveredAsset] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const previewTimerRef = useRef(null);
  const containerRef = useRef(null);
  const [count, setCount] = useState(0); // ??? ????????
  const location = useLocation(); 
  const fontContext = useFontSize();
  const fontSize = fontContext?.fontSize || 13;
  const changeFontSize = fontContext?.changeFontSize || (() => {});
  const [failureLists, setFailureLists] = useState({ problems: [], causes: [], remedies: [] });
  const [wfContext, setWfContext] = useState({ can_start: false, can_action: false });
  const { canCreate, canUpdate, canDelete } = usePermissions('workorders');
  const isEditable = !isReadOnly && (isNew ? canCreate : canUpdate);
  

  const FontControls = () => {
    const { fontSize, changeFontSize } = useFontSize();
  
    return (
      <div className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full border border-white/20 ml-4">
        <button onClick={() => changeFontSize(-1)} className="hover:text-orange-400 transition-colors">
          <Minus size={14} />
        </button>
        <div className="flex items-center gap-1 min-w-[40px] justify-center">
          <Type size={14} />
          <span className="font-black text-[10px]">{fontSize}</span>
        </div>
        <button onClick={() => changeFontSize(1)} className="hover:text-orange-400 transition-colors">
          <Plus size={14} />
        </button>
      </div>
    );
  };

  const [nav, setNav] = useState({ 
    first: null, last: null, next: null, prev: null, total: 0, current_pos: 0 
  });

  const [taskStatusConfig, setTaskStatusConfig] = useState({ 
    isOpen: false, 
    taskid: null, 
    currentStatus: '',
    index: null 
  });  
  
  const session = JSON.parse(localStorage.getItem('user') || '{}');
  const sessionSite = session.site_id || '';
  const sessionOrg = session.org_id || '';
  const currency = session.currency || 'EGP';
    
  const [data, setData] = useState({
    wonum: '', description: '', status: 'WAPPR', wo_type: 'CM', location_id: '', location_description: '', assetnum: '', safetypnum : '',
    asset_description: '', site_id: sessionSite, org_id: sessionOrg, supervisor: '',
    targstartdate: '', targcompdate: '', scheddate: '', schedfinish: '',  earlystart: '', latefinish: '',
    actstart: '', actfinish: '', slanum: '',
    tasks: [], planned_labor: [], planned_materials: [],
    actual_labor: [], actual_materials: [], failure_reports: [], assignments: [],actual_tools: [], 
    actual_services: [], safety_hazards: [], safety_precautions: [], loto_steps: [], wofailure: []
  });

  const [lookup, setLookup] = useState({ isOpen: false, title: '', type: '', domainId: '', field: '' });

  const loadWO = useCallback(async () => {

    try {
          const [woMaps, meterMaps] = await Promise.all([
              axios.get('/api/admin/field-map/workorders'),
              axios.get('/api/admin/field-map/Meters')
          ]);
          setFieldMaps({
              ...(woMaps.data || {}),
              ...(meterMaps.data || {}) 
          });    
      if (isNew) return;
      const res = await axios.get(`/api/workorder/${id}`);
      setData(res.data);
    } catch (err) { toast.error(t('wo.messages.loadError')); }
  }, [id, isNew]);

  useEffect(() => {
    if (isNew && data.org_id) {
        setData(prev => ({
          ...prev,
          description: '',
          status: 'WAPPR',
          site_id: session.site_id || '',
          org_id: session.org_id || '',
          requestedby: session.username || '',
          location_id: '',
          duration: 0.0,
          wo_type: 'CM', assetnum: '', safetypnum : '',
          asset_description: '', site_id: sessionSite, org_id: sessionOrg, supervisor: '',
          targstartdate: '', targcompdate: '', scheddate: '', schedfinish: '',  earlystart: '', latefinish: '',
          actstart: '', actfinish: '', failure_class: '',
          tasks: [], planned_labor: [], planned_materials: [], wofailure: [], wohazards: [], woloto: [],
          actual_labor: [], actual_materials: [], failure_reports: [], assignments: [],actual_tools: [], actual_services: [], safety_hazards: [], safety_precautions: [], loto_steps: []
          
        }));         
        axios.get(`/api/wo/next-number/${data.org_id}`)
            .then(res => {
                setData(prev => ({ ...prev, wonum: res.data.next_wonum }));
            });
    }
  }, [isNew, data.org_id]);
  useEffect(() => { loadWO(); }, [loadWO]);
  const isReadOnly = data.status === 'APPROVED' || data.status === 'APPR' || data.status === 'CLOSE' || data.status === 'CAN' || data.status === 'CLOSED' || data.status === 'COMP';
  
  const loadNavigation = useCallback(async () => {
    if (isNew) return;
    
    const token = localStorage.getItem('token');
    const searchParams = new URLSearchParams(location.search); 

    const columnFilterSite = searchParams.get('site_id');
    const isGlobal = searchParams.get('all_sites') === 'true';

    try {
      const res = await axios.get(`/api/workorder/${id}/navigation`, {
        params: {
          // 1. بارامترات النطاق
          all_sites: isGlobal,
          site_id: sessionSite, // سيشن اليوزر الحالية
          org_id: sessionOrg,
          
          // 2. بارامترات الفلترة (عشان النافيجيشن يلتزم بنفس نتايج البحث)
          filter_site: columnFilterSite, // 🚀 هنا الربط اللي كان ناقص
          searchTerm: searchParams.get('searchTerm'),
          status: searchParams.get('status'),
          wonum: searchParams.get('wonum'),
          description: searchParams.get('description'),
          assetnum: searchParams.get('assetnum'),
          location_id: searchParams.get('location_id')
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      setNav(res.data || { first: null, last: null, next: null, prev: null, total: 0, current_pos: 0 });
    } catch (err) { 
      console.error("Nav load failed", err);
      setNav({ first: null, last: null, next: null, prev: null, total: 0, current_pos: 0 });
    }
  }, [id, isNew, location.search, sessionSite, sessionOrg]);

  const fetchCount = useCallback(async () => {
    if (!data.wonum || isNew) {
        setCount(0);
        return;
    }
    try {
      const res = await axios.get(`/api/attachments/count/WO/${data.wonum}`);
      setCount(res.data.count || 0);
    } catch (err) { 
        console.error("Error fetching attachment count:", err); 
    }
  }, [data.wonum, isNew]);  
  
  const closePreview = useCallback(() => {
    if (previewTimerRef.current) clearTimeout(previewTimerRef.current);
    setHoveredAsset(null);
  }, []);

  // 3. دالة الدخول (فتح البريفيو)
  const handleMouseEnter = async (e, assetnum) => {
    if (!assetnum) return;
    if (previewTimerRef.current) clearTimeout(previewTimerRef.current);
    
    setMousePos({ x: e.clientX, y: e.clientY });
    try {
      const res = await axios.get(`/api/getassets/${assetnum}`);
      setHoveredAsset(res.data);
    } catch (err) { console.error("Asset info not found"); }
  };

  // 4. دالة الخروج (بتايم أوت قصير للأمان)
  const handleMouseLeave = () => {
    previewTimerRef.current = setTimeout(() => {
      setHoveredAsset(null);
    }, 100); // 100ms كافية جداً
  };

  // 5. 🎯 الحل السحري: مراقبة النقر (Click) وحركة الماوس العالمية
  useEffect(() => {
    const handleGlobalClick = (e) => {
      // لو المستخدم داس في أي حتة، اقفل البريفيو فوراً
      closePreview();
    };

    const handleGlobalMouseMove = (e) => {
      // لو البريفيو ظاهر، بنعمل فحص مسافة
      if (hoveredAsset) {
        const dist = Math.sqrt(
          Math.pow(e.clientX - mousePos.x, 2) + 
          Math.pow(e.clientY - mousePos.y, 2)
        );
        // لو الماوس ابتعد أكتر من 300 بيكسل عن مكان ظهوره الأصلي، اقفله (Safety Valve)
        if (dist > 350) closePreview();
      }
    };

    window.addEventListener('mousedown', handleGlobalClick);
    window.addEventListener('mousemove', handleGlobalMouseMove);
    
    return () => {
      window.removeEventListener('mousedown', handleGlobalClick);
      window.removeEventListener('mousemove', handleGlobalMouseMove);
    };
  }, [hoveredAsset, mousePos, closePreview]);

  const handleTaskStatusClick = (row, idx) => {

    if (!row.taskid) {
      const nextStatus = row.status === 'WAPPR' ? 'APPR' : 'WAPPR';
      updateRow('tasks', idx, 'status', nextStatus);
      updateRow('tasks', idx, 'status', nextStatus);
      toast.success(t('wo.messages.taskStatusLocal'));
      return;
    }
    
    setTaskStatusConfig({
      isOpen: true,
      taskid: row.taskid,
      currentStatus: row.status,
      index: idx
    });
  };
  
  const handleCreateMR = async (materialItem) => {
    // 1. Validation: Ensure item and store are selected
    if (!materialItem.itemnum || !materialItem.fromstore) {
      return toast.error(t('wo.messages.selectItemStore'));
    }
  
    // 2. Local check: Avoid duplicate requests for the same item
    const isAlreadyRequested = data.related_mrs?.some(
      mr => mr.description.includes(materialItem.itemnum) && mr.status !== 'CAN'
    );
  
    if (isAlreadyRequested) {
      const confirm = await Swal.fire({
        title: t('wo.messages.duplicateReqTitle'),
        text: t('wo.messages.duplicateReqText', { item: materialItem.itemnum }),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1a3353',
        cancelButtonColor: '#d33',
        confirmButtonText: t('wo.actions.yesCreate'),
        cancelButtonText: t('common.cancel')
      });
      if (!confirm.isConfirmed) return;
    }
  
    const loadId = toast.loading(t('wo.messages.creatingMR'));
  
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const token = localStorage.getItem('token');

      const payload = {
        wonum: data.wonum,
        itemnum: materialItem.itemnum,
        quantity: materialItem.quantity,
        fromstore: materialItem.fromstore,
        site_id: data.site_id,
        org_id: data.org_id,
        description: `MR for WO ${data.wonum}: ${materialItem.itemnum}`
      };
  
      // Direct API call to create MR
      const res = await axios.post('/api/workorder/create-direct-mr', payload,
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
      
      if (res.data.status === 'success') {
        toast.success(t('wo.messages.mrCreated', { num: res.data.mrnum }), { id: loadId });
        
        // 🎯 Update state immediately to reflect changes in UI
        setData(prev => ({
          ...prev,
          related_mrs: [...(prev.related_mrs || []), res.data.new_mr],
          status: 'WMAT' // Auto-change WO status to Waiting for Material
        }));
      }
    } catch (err) {
        toast.error(err.response?.data?.detail || t('wo.messages.mrFail'), { id: loadId });
    }
  };
  
  const handleWOStatusAction = async (targetStatus, actionLabel) => {
    // 1. رسالة تأكيد احترافية باستخدام SweetAlert2
    const result = await Swal.fire({
      title: `${t('common.confirm')} ${actionLabel}`,
      text: t('wo.messages.confirmStatusChange', { wonum: data.wonum, status: targetStatus }),
      icon: targetStatus === 'CAN' ? 'warning' : 'question',
      showCancelButton: true,
      confirmButtonColor: targetStatus === 'CAN' ? '#d33' : '#1a3353',
      confirmButtonText: t('wo.actions.yesChange'),
      cancelButtonText: t('common.cancel')
    });
  
    if (!result.isConfirmed) return;
  
    const loadId = toast.loading(`${actionLabel} in progress...`);
  
    try {
      const token = localStorage.getItem('token');
      
      // 2. نداء الباكيند (نفس الدالة اللي كتبناها سوا)
      const res = await axios.post(
        `/api/workorder/${data.wonum}/change-status`, 
        { new_status: targetStatus },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );
  
      if (res.data.status === 'success') {
        toast.success(t('wo.messages.statusSuccess'), { id: loadId });
        loadWO();
        
        // 3. تحديث البيانات في الشاشة فوراً عشان الأزرار تتغير أو تختفي
        setData(prev => ({ 
          ...prev, 
          status: targetStatus,
          // تحديث التواريخ لو الباكيند رجعها
          actual_start: res.data.actual_start || prev.actual_start,
          actual_finish: res.data.actual_finish || prev.actual_finish
        }));
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || t('wo.messages.statusFail'), { id: loadId });
    }
  };
  
  const handleSave = async () => {
    const loadId = toast.loading(t('wo.messages.saving'));
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/workorder/save', data, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      toast.success(t('common.save_success'), { id: loadId });
            navigate(`/workorders/${data.wonum}${location.search}`, { replace: true });
    } catch (err) { toast.error(t('common.saveFail'), { id: loadId }); }
  };

  const handleDelete = async () => {
        // رسالة تأكيد بنمط ماكسيمو
        const result = await Swal.fire({
            title: t('common.are_you_sure'),
            text: t('wo.messages.deleteConfirm', { wonum: data.wonum }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('common.delete'),
            cancelButtonText: t('common.cancel'),
            customClass: { popup: `${isRTL ? 'font-cairo' : 'font-sans'} text-[12px]` }
        });

        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem('token');
                await axios.delete(`/api/workorder/${data.wonum}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                
              toast.success(t('common.delete_success'));
                navigate('/workorders'); // العودة للقائمة بعد الحذف
            } catch (err) {
              toast.error(err.response?.data?.detail || t('common.delete_fail'));
            }
        }
    };

  const handleApplySLA = async () => {
      // 1. التأكد إن أمر الشغل محفوظ (له ID)
      if (isNew) {
          return toast.error(t('wo.messages.saveBeforeSLA'));
      }
      if (data.slanum) {
          return toast.error(t('wo.messages.slaExists'));
      }
      const tid = toast.loading(t('wo.messages.matchingSLA'));
      try {
          const token = localStorage.getItem('token');
          // 2. نداء الـ API اللي إنت لسه كاتبه في الباكيند
          const res = await axios.post(`/api/system/apply-sla-to-wo`, null, {
              params: { wo_id: data.wo_id }, // بنبعت الـ ID كـ Query Param
              headers: { 'Authorization': `Bearer ${token}` }
          });

          if (res.data === true) {
              toast.success(t('wo.messages.slaApplied'), { id: tid });
              // 3. تحديث البيانات في الشاشة عشان الـ Widget والتواريخ تظهر
              loadWO(); 
          } else {
              toast.error(t('wo.messages.noMatchingSLA'), { id: tid });
          }
      } catch (err) {
          toast.error(t('wo.messages.slaError'), { id: tid });
      }
  };

  const handleSmartSearch = (fieldName, title, defaultType, onCustomSelect = null) => {
    const linkedDomain = (fieldMaps || {})[fieldName];
    setLookup({ 
      isOpen: true, 
      title, 
      type: linkedDomain ? 'DOMAIN' : defaultType, 
      domainId: linkedDomain || '', 
      field: fieldName,
      onCustomSelect: onCustomSelect
    });
  };
  
  const handleSearch = (fieldName, title, defaultType, lineIdx = null) => {
    let extraFilters = { site_id: data.site_id, org_id: data.org_id };
    if (fieldName === 'ref_mrnum') extraFilters.status = 'APPR'; 
    if (fieldName === 'assetnum') extraFilters.location = data.location_id;

    setLookup({
      isOpen: true,
      title: title,
      type: defaultType,
      field: fieldName,
      filters: extraFilters,
      targetIdx: lineIdx
    });
  };

  const fetchSafetyPlanDetails = async (spNum) => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`/api/safety-plans/${spNum}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        
        // تحديث الداتا بجداول السيفتي (Hazards, LOTO)
        setData(prev => ({
            ...prev,
            wohazards: res.data.hazards || [],
            woloto: res.data.woloto || []
        }));
    } catch (err) {
        console.error("Failed to fetch safety plan details", err);
    }
  };

  const fetchFailureTree = async (className) => {
  if (!className) return;
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/failure-classes-by-name/${className}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    
    // 1. تخزين القوائم للبحث اللاحق (المنيو)
    setFailureLists({
      problems: res.data.problems || [],
      causes: res.data.causes || [],
      remedies: res.data.remedies || []
    });

    // 2. 🎯 حقن أول مشكلة وأول سبب أوتوماتيك في جدول الفيلر
    const autoFailures = [];
    
    if (res.data.problems && res.data.problems.length > 0) {
      autoFailures.push({
        failure_type: 'PROBLEM',
        failure_code: res.data.problems[0].code,
        description: res.data.problems[0].description
      });
    }
    
    if (res.data.causes && res.data.causes.length > 0) {
      autoFailures.push({
        failure_type: 'CAUSE',
        failure_code: res.data.causes[0].code,
        description: res.data.causes[0].description
      });
    }

    // تحديث الحالة لتبدأ بالبيانات دي
    setData(prev => ({ ...prev, wofailure: autoFailures }));
    
    toast.success(t('wo.messages.failureTreeLoaded', { class: className }));
  } catch (err) {
    console.error("Failure Tree load failed", err);
  }
};
  
  const addFailureRow = (type) => {
    const newRow = { failure_type: type, failure_code: '', description: '' };
    setData(prev => ({ ...prev, wofailure: [...(prev.wofailure || []), newRow] }));
  };

  const updateFailureRow = (idx, field, value, description = '') => {
    const newList = [...data.wofailure];
    newList[idx] = { ...newList[idx], [field]: value, description: description };
    setData(prev => ({ ...prev, wofailure: newList }));
  };

  const handleLookupSelect = (row) => {
    const val = row.taxid || row.mrnum || row.safetypnum || row.laborcode || row.craft_code || row.value || row.assetnum || row.location_id || row.id || row.itemnum || row.comp_num ;
    if (lookup.field === 'row_plan_craft' && lookup.targetIdx !== null) {
        updateRow('planned_labor', lookup.targetIdx, 'craft', row.craft_code || row.value);
      } 
    else if (lookup.field === 'row_plan_labor' && lookup.targetIdx !== null) {
        updateRow('planned_labor', lookup.targetIdx, 'laborcode', row.laborcode || row.value);
        // لو حابب تسحب المهنة ومعدل الأجر أوتوماتيك مع العامل:
        if(row.craft_code) updateRow('planned_labor', lookup.targetIdx, 'craft', row.craft_code);
        if(row.actual_rate) updateRow('planned_labor', lookup.targetIdx, 'laborrate', row.actual_rate);
      }
    else if(lookup.field === 'row_plan_item' && lookup.targetIdx !== null){
        updateMaterialRow(lookup.targetIdx, 'itemnum', row.itemnum || row.value);
        if(row.description) updateMaterialRow(lookup.targetIdx, 'description', row.description);
        if (row.avgcost || row.lastcost) {
            updateMaterialRow(lookup.targetIdx, 'unitcost', row.avgcost || row.lastcost);
        }
    }
    else if(lookup.field === 'row_plan_store' && lookup.targetIdx !== null){
        updateMaterialRow(lookup.targetIdx, 'fromstore', row.location || row.value);
    
    }
    // أضف هذه الشروط داخل handleLookupSelect
    else if (lookup.field === 'row_assign_craft' && lookup.targetIdx !== null) {
        updateAssignmentRow(lookup.targetIdx, 'craft', row.craft_code || row.value);
    } 
    else if (lookup.field === 'row_assign_labor' && lookup.targetIdx !== null) {
        updateAssignmentRow(lookup.targetIdx, 'laborcode', row.laborcode || row.value);
        // سحب المهنة والمعدل أوتوماتيك من العامل المختار
        if(row.craft_code) updateAssignmentRow(lookup.targetIdx, 'craft', row.craft_code);
        if(row.actual_rate) updateAssignmentRow(lookup.targetIdx, 'laborrate', row.actual_rate);
    }
           
    // أضف هذه الشروط داخل handleLookupSelect
    else if (lookup.field === 'row_act_labor' && lookup.targetIdx !== null) {
        updateActualLaborRow(lookup.targetIdx, 'laborcode', row.laborcode || row.value);
        if(row.actual_rate) updateActualLaborRow(lookup.targetIdx, 'laborrate', row.actual_rate);
    }
    else if (lookup.field === 'row_act_item' && lookup.targetIdx !== null) {
        updateActualMaterialRow(lookup.targetIdx, 'itemnum', row.itemnum || row.value);
        if(row.avgcost) updateActualMaterialRow(lookup.targetIdx, 'unitcost', row.avgcost);
    }   
    else if (lookup.field === 'row_act_tool' && lookup.targetIdx !== null) {
        const newList = [...data.actual_tools];
        newList[lookup.targetIdx].toolnum = row.itemnum || row.value;
        newList[lookup.targetIdx].toolrate = row.toolrate || 0;
        setData({ ...data, actual_tools: newList });
    }
    else if (lookup.field === 'row_act_store' && lookup.targetIdx !== null) {
        const selectedStore = row.location || row.value;
        const currentItem = data.actual_materials[lookup.targetIdx]?.itemnum;
    
        const newList = [...data.actual_materials];
        newList[lookup.targetIdx].fromstore = selectedStore;
        setData({ ...data, actual_materials: newList });
    
        if (currentItem) {
            // نبعت نجيب السعر والرصيد في نفس الطلب
            axios.get(`/api/inventory/details/${selectedStore}/${currentItem}`)
                .then(res => {
                    const { avgcost, curbal } = res.data;
                    
                    // تحديث السعر
                    updateActualMaterialRow(lookup.targetIdx, 'unitcost', avgcost || 0);
    
                    // التحقق من الرصيد
                    if (!curbal || curbal <= 0) {
                        toast.error(`⚠️ تحذير: الصنف رصيده (صفر) في مخزن ${selectedStore}`, {
                            duration: 5000,
                            style: { border: '1px solid #ff4b4b', padding: '16px', color: '#ff4b4b' }
                        });
                    } else {
                        toast.success(`تم جلب السعر: ${avgcost} - الرصيد المتاح: ${curbal}`);
                    }
                })
                .catch(() => toast.error("فشل في الاتصال بسجلات المخزن"));
        }
    }             
        if (lookup.field === 'ref_mrnum') {
      fetchAndFillMR(val);
    } else if (lookup.field === 'tax_id') {
      const newLines = [...data.lines];
      const idx = lookup.targetIdx;
      newLines[idx].tax_id = row.taxid;
      newLines[idx].taxrate = row.taxrate || 0;
      recalculateTotals(newLines);
    } else if (lookup.field === 'itemnum' && lookup.targetIdx !== null) {
      const newLines = [...data.lines];
      const idx = lookup.targetIdx;
      newLines[idx].itemnum = row.itemnum;
      newLines[idx].description = row.description;
      newLines[idx].unitcost = row.avgcost || 0;
      if (row.tax_id) {
          newLines[idx].tax_id = row.tax_id;
          newLines[idx].taxrate = row.taxrate || 0;
      }
      recalculateTotals(newLines);
    } else if (lookup.field === 'assetnum') {
      // 🎯 تحديث بيانات الأصل + الفيلر كلاس + السيفتي بلان
      setData(prev => ({
        ...prev,
        assetnum: row.assetnum,
        asset_description: row.description,
        location_id: row.location_id || prev.location_id,
        failure_class: row.failure_class || '', // سحب الفيلر كلاس من موديل الـ Asset
        safetypnum: row.safetypnum || ''        // سحب السيفتي بلان من موديل الـ Asset
      }));

      // 🚀 إطلاق صاروخ الفيتش للسيفتي بلان فوراً
      if (row.safetypnum) {
        fetchSafetyPlanDetails(row.safetypnum);
      } else {
        // تصفير تابة السيفتي لو مفيش بلان
        setData(prev => ({ ...prev, wohazards: [], woloto: [] }));
      }
      if (row.failure_class) {
        fetchFailureTree(row.failure_class);
      }
      
      toast.success(`Asset Linked: ${row.assetnum}`);
    } 
    // شرط الفايلر كودز المختار يدوياً (لو حبيت تختارهم في تابة الفايلر)
    else if (['problem_code', 'cause_code', 'remedy_code'].includes(lookup.field)) {
      // lookup.targetIdx ده لازم نكون باعتينه من الـ FailureTable
      const targetIdx = lookup.targetIdx; 
      
      if (targetIdx !== null && targetIdx !== undefined) {
        const newList = [...data.wofailure];
        newList[targetIdx] = { 
          ...newList[targetIdx], 
          failure_code: row.code, 
          description: row.description 
        };
        
        setData(prev => ({ ...prev, wofailure: newList }));
      }
    } else {
      setData({ ...data, [lookup.field]: val });
    }
    setLookup({ ...lookup, isOpen: false });
  };
  
  // Add tools & services to Actuals
  const addRow = (listName) => {
      let newRow = {};
      if (listName === 'actual_labor') {
          newRow = { laborcode: '', startdate: '', finishdate: '', regularhrs: 0, laborrate: 0, linecost: 0 };
      } else if (listName === 'actual_materials') {
          newRow = { itemnum: '', fromstore: '', quantity: 1, unitcost: 0, linecost: 0 };
      } else if (listName === 'actual_tools') {
          newRow = { toolnum: '', hours: 0, toolrate: 0, linecost: 0 };
      } else if (listName === 'actual_services') {
          newRow = { description: '', vendor: '', linecost: 0 };
      }
      setData(prev => ({ ...prev, [listName]: [...(prev[listName] || []), newRow] }));
  };  
  // Tab (Assignments)
  const addAssignmentRow = () => {
    const newRow = { 
      description: '', 
      status: 'ASSIGNED', 
      craft: '', 
      laborcode: '', 
      quantity: 1, 
      laborhrs: 0.0, 
      laborrate: 0.0, 
      linecost: 0.0 
    };
    setData({ ...data, assignments: [...data.assignments, newRow] });
  };
  
  // دالة التحديث الذكي للتكليفات (لحساب التكاليف فوراً)
  const updateAssignmentRow = (idx, field, value) => {
    const newList = [...data.assignments];
    newList[idx][field] = value;
  
    // إعادة حساب التكلفة لو تغيرت الساعات أو المعدل أو الكمية
    if (['quantity', 'laborhrs', 'laborrate'].includes(field)) {
      const row = newList[idx];
      newList[idx].linecost = (row.quantity || 0) * (row.laborhrs || 0) * (row.laborrate || 0);
    }
    setData({ ...data, assignments: newList });
  };  
  // --- ???? ?????? (Tasks) ---
  const addTaskRow = () => {
    const newRow = { 
      wosequence: (data.tasks.length + 1) * 10, 
      description: '', 
      estdur: 1.0, 
      status: 'WAPPR' 
    };
    setData({ ...data, tasks: [...data.tasks, newRow] });
  };
  
  // ---  (Planned Labor) ---
  const addLaborRow = () => {
    const newRow = { 
      taskid: null, craft: '', laborcode: '',
      quantity: 1, laborhrs: 0, laborrate: 0, linecost: 0 
    };
    setData({ ...data, planned_labor: [...data.planned_labor, newRow] });
  };
  
  // --- ???? ????? ?????? ---
  const removeRow = (listName, index) => {
    const newList = [...data[listName]];
    newList.splice(index, 1);
    setData({ ...data, [listName]: newList });
  };

    
  // ---  (Smart Update) ---
  const updateRow = (listName, index, field, value) => {
    const newList = [...data[listName]];
    newList[index][field] = value;
  
    if (listName === 'planned_labor' && ['quantity', 'laborhrs', 'laborrate'].includes(field)) {
      const row = newList[index];
      newList[index].linecost = (row.quantity || 0) * (row.laborhrs || 0) * (row.laborrate || 0);
    }
    
    setData({ ...data, [listName]: newList });
  };
  
  // (Materials) ---
  const addMaterialRow = () => {
    const newRow = { 
      linetype: 'ITEM', itemnum: '', description: '', 
      quantity: 1, unitcost: 0, linecost: 0, fromstore: '' 
    };
    setData({ ...data, planned_materials: [...data.planned_materials, newRow] });
  };
  
  // (Tools) ---
  const addToolRow = () => {
    const newRow = { 
      itemnum: '', description: '', quantity: 1, 
      toolrate: 0, linecost: 0, hours: 0 
    };
    setData({ ...data, planned_tools: [...(data.planned_tools || []), newRow] });
  };
  
  const updateMaterialRow = (idx, field, value) => {
    const newList = [...data.planned_materials];
    newList[idx][field] = value;
    
    if (field === 'quantity' || field === 'unitcost') {
      newList[idx].linecost = (newList[idx].quantity || 0) * (newList[idx].unitcost || 0);
    }
    setData({ ...data, planned_materials: newList });
  };  
  
  // --- تابة التنفيذ الفعلي (Actuals) ---
  
  // إضافة عامل فعلي
  const addActualLaborRow = () => {
    const newRow = { 
      laborcode: '', startdate: '', finishdate: '', 
      regularhrs: 0.0, laborrate: 0.0, linecost: 0.0 
    };
    setData({ ...data, actual_labor: [...data.actual_labor, newRow] });
  };
  
  // إضافة مواد فعلية
  const addActualMaterialRow = () => {
    const newRow = { 
      itemnum: '', quantity: 1.0, unitcost: 0.0, linecost: 0.0 
    };
    setData({ ...data, actual_materials: [...data.actual_materials, newRow] });
  };
  
  const calculateHours = (start, finish) => {
    if (!start || !finish) return 0;
    const diff = new Date(finish) - new Date(start);
    return Math.max(0, (diff / (1000 * 60 * 60)).toFixed(2)); // تحويل لكسر عشري
  };
  
  const updateActualLaborRow = (idx, field, value) => {
    const newList = [...data.actual_labor];
    newList[idx][field] = value;
  
    // ���� السحر هنا: حساب الساعات تلقائياً
    if (field === 'startdate' || field === 'finishdate') {
      const hrs = calculateHours(newList[idx].startdate, newList[idx].finishdate);
      newList[idx].regularhrs = hrs;
    }
  
    // إعادة حساب التكلفة
    newList[idx].linecost = (newList[idx].regularhrs || 0) * (newList[idx].laborrate || 0);
    setData({ ...data, actual_labor: newList });
  };
  
  const updateActualMaterialRow = (idx, field, value) => {
    const newList = [...data.actual_materials];
    newList[idx][field] = value;
    // حساب التكلفة
    if (['quantity', 'unitcost'].includes(field)) {
      newList[idx].linecost = (newList[idx].quantity || 0) * (newList[idx].unitcost || 0);
    }
    setData({ ...data, actual_materials: newList });
  };  
  
  const getPlannedTotal = () => {
    const labor = data.planned_labor?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0;
    const materials = data.planned_materials?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0;
    const tools = data.planned_tools?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0;
    return labor + materials + tools;
  };
  
  const getActualTotal = () => {
    const labor = data.actual_labor?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0;
    const materials = data.actual_materials?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0;
    const tools = data.actual_tools?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0;
    const services = data.actual_services?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0;
    return labor + materials + tools + services;
  };  
  
  const handleStatusChangeInitiation = () => {
    const actual = getActualTotal();
    const planned = getPlannedTotal();
    
  // 2. فحص الأسايمنتس المفتوحة (Front-end Check)
    const openAssignments = data.assignments?.filter(a => 
      !['COMPLETED', 'CANCELED'].includes(a.status)
    ).length;
  
    if (openAssignments > 0) {
      return toast.error(t('wo.messages.openAssignError', { count: openAssignments }), { duration: 5000 });
    }    
    // ���� التركاية هنا: لو الميزانية اتخرمت (الفعلي > المخطط)
    if (actual > planned && planned > 0) {
      toast((t) => (
        <span className="flex flex-col gap-2 text-[0.8]">
          <b className="text-red-600 uppercase">⚠️{t('wo.messages.budgetExceeded')}</b>
          <span>{t('wo.tabs.actuals')}: {actual.toLocaleString()} | {t('wo.tabs.plans')}: {planned.toLocaleString()}</span>
          <div className="flex gap-2 mt-2">
            <button 
              className="bg-red-600 text-white px-3 py-1 rounded-sm font-black uppercase"
              onClick={() => {
                toast.dismiss(t.id);
                // هنا ممكن نفتح المودال بس نبعت flag إنه محتاج تعليق تبرير (Justification)
                setShowStatusModal(true); 
              }}
            >
              {t('common.confirm')}
            </button>
            <button className="border px-3 py-1" onClick={() => toast.dismiss(t.id)}>{t('common.cancel')}</button>
          </div>
        </span>
      ), { duration: 6000, position: 'top-center' });
    } else {
      setShowStatusModal(true);
    }
  };  

  const handleCompleteAssignment = (idx) => {
    const newList = [...data.assignments];
    
    // تحديث الحالة لـ COMPLETED
    newList[idx].status = 'COMPLETED';
    
  
    setData({ ...data, assignments: newList });
    
    toast.success(t('wo.messages.assignComplete'), {
      icon: '✅',
      style: { borderRadius: '4px', background: '#333', color: '#fff', fontSize: '12px' }
    });
  };
  
  useEffect(() => {
    const triggerAppr = () => {
        if (isNew || !data.wonum) {
          console.log("⚠️ Document is new, skipping SideMenu trigger.");
          return;
        }
        if (['APPR', 'COMP', 'CLOSE', 'CAN'].includes(data.status)) {
        return toast.error(t('wo.messages.actionNotAllowed', { status: data.status }), {
          icon: '❌',
          style: { borderRadius: '4px', background: '#333', color: '#fff', fontSize: '12px' }
        });
      }
      handleWOStatusAction('APPR', t('wo.actions.approve'));
    };
    window.addEventListener('GLOBAL_APPR_WO', triggerAppr);
    return () => window.removeEventListener('GLOBAL_APPR_WO', triggerAppr);
  }, [handleWOStatusAction, data.status]);
  
  useEffect(() => {
    if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
    }
    const triggerCancel = () => {
        if (['APPR', 'COMP', 'CLOSE', 'CAN'].includes(data.status)) {
        return toast.error(t('wo.messages.actionNotAllowed', { status: data.status }), {
          icon: '❌',
          style: { borderRadius: '4px', background: '#333', color: '#fff', fontSize: '12px' }
        });
      }
      handleWOStatusAction('CAN', t('wo.actions.cancel'));
    };
    window.addEventListener('GLOBAL_CAN_WO', triggerCancel);
    return () => window.removeEventListener('GLOBAL_CAN_WO', triggerCancel);
  }, [handleWOStatusAction, data.status]);
  
  useEffect(() => {
    const triggerStW = () => {
      if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
      }
      // 1. التحقق لازم يكون جوه الدالة عشان يشتغل عند النداء فقط
      if (['WAPPR', 'COMP', 'CLOSE', 'CAN'].includes(data.status)) {
        return toast.error(t('wo.messages.actionNotAllowed', { status: data.status }), {
          icon: '❌',
          style: { borderRadius: '4px', background: '#333', color: '#fff', fontSize: '12px' }
        });
      }
      
      // 2. لو الحالة صح، نفذ الأكشن
      handleWOStatusAction('INPRG', t('wo.actions.startWork'));
    };

    window.addEventListener('GLOBAL_STRT_WO', triggerStW);
    return () => window.removeEventListener('GLOBAL_STRT_WO', triggerStW);
  }, [handleWOStatusAction, data.status]); 
  
    useEffect(() => {
    const triggerCloseW = () => {
      if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
      }
      // 1. التحقق لازم يكون جوه الدالة عشان يشتغل عند النداء فقط
      if (data.status !== 'COMP') {
        return toast.error(t('wo.messages.actionNotAllowed', { status: data.status }), {
          icon: '❌',
          style: { borderRadius: '4px', background: '#333', color: '#fff', fontSize: '12px' }
        });
      }
      
      // 2. لو الحالة صح، نفذ الأكشن
      handleWOStatusAction('CLOSE', t('wo.actions.close'));
    };

    window.addEventListener('GLOBAL_CLOSE_WO', triggerCloseW);
    return () => window.removeEventListener('GLOBAL_CLOSE_WO', triggerCloseW);
  }, [handleWOStatusAction, data.status]); 
  
  useEffect(() => {
    const triggerCompW =  () => {
      //await loadWO(); // غيرتها لـ loadWO عشان تجيب الداتا الصح
    
    // 🎯 البوابة: لو السجل لسه جديد أو ملوش wonum حقيقي، اخرج وما تفتحش المنيو
    if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
    }
      // 1. التحقق لازم يكون جوه الدالة عشان يشتغل عند النداء فقط
      if (data.status !== 'INPRG') {
        return toast.error(t('wo.messages.actionNotAllowed', { status: data.status }), {
          icon: '❌',
          style: { borderRadius: '4px', background: '#333', color: '#fff', fontSize: '12px' }
        });
      }
      
      // 2. لو الحالة صح، نفذ الأكشن
      handleWOStatusAction('COMP', t('wo.actions.complete'));
    };

    window.addEventListener('GLOBAL_COMP_WO', triggerCompW);
    return () => window.removeEventListener('GLOBAL_COMP_WO', triggerCompW);
  }, [handleWOStatusAction, data.status]); 
  
  useEffect(() => {
    if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
    }
    const triggerDelete = () => handleDelete();
    window.addEventListener('GLOBAL_DELETE_HANDLER', triggerDelete);
    return () => window.removeEventListener('GLOBAL_DELETE_HANDLER', triggerDelete);
  }, [handleDelete]);

  useEffect(() => {
    if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
    }
    const triggerSLA = () => handleApplySLA();
    window.addEventListener('GLOBAL_SLA_HANDLER', triggerSLA);
    return () => window.removeEventListener('GLOBAL_SLA_HANDLER', triggerSLA);
  }, [handleApplySLA]);

  handleApplySLA
  
  useEffect(() => {
    if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
    }
    const openStatusModal = () => {
        if (isReadOnly && data.status === 'CAN') return Swal.fire({title: t('wo.messages.locked'), text: t('wo.messages.cantChangeCancel'), icon: 'lock'});
        setShowStatusModal(true);
    };
    window.addEventListener('GLOBAL_STATUS_HANDLER', openStatusModal);
    return () => window.removeEventListener('GLOBAL_STATUS_HANDLER', openStatusModal);
  }, [isReadOnly]);

  useEffect(() => {
    if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
    }
    const handleOpenHistory = () => {
      setShowHistoryModal(true);
    };
    window.addEventListener('OPEN_STATUS_HISTORY', handleOpenHistory);
    return () => {
      window.removeEventListener('OPEN_STATUS_HISTORY', handleOpenHistory);
    };
  }, []);

  useEffect(() => {
    if (isNew || !data.wonum) {
        console.log("⚠️ Document is new, skipping SideMenu trigger.");
        return;
    }
    const handleOpenWFHistory = () => {
      setIsWFHistoryOpen(true);
    };
    window.addEventListener('OPEN_WF_HISTORY', handleOpenWFHistory);
    return () => {
      window.removeEventListener('OPEN_WF_HISTORY', handleOpenWFHistory);
    };
    }, []);  
  
    useEffect(() => {
    fetchCount();
  }, [data.wonum, fetchCount]);

  useEffect(() => {
      loadNavigation();
  }, [loadNavigation]);    
  const goTo = (targetWonum) => {
    if (targetWonum) {
      navigate(`/workorders/${targetWonum}${location.search}`);
    }
  };

  const handlePrintSafetySheet = async () => {
    if (isNew ) return;
    try {
      const response = await axios.post( 
        `/api/print-safety-sheet/${data.wonum}`,
        data, 
        { responseType: 'blob' } 
      );
      const file = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (error) {
      console.error("Print Safety Sheet Error:", error);
      toast.error(t('wo.messages.printFail'));
    }
  };

  const handlePrint = async () => {
    if (isNew ) return;
    try {
      const response = await axios.post(
        `/api/print-wo/${data.wonum}`, 
        data,
        { responseType: 'blob' }
      );
  
      // تحويل الـ Blob لرابط وفتحه في صفحة جديدة
      const file = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (error) {
      console.error("Print Error:", error);
      toast.error(t('wo.messages.printFail'));
    }
  };

  const handleRouteWorkflow = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/workflow/initiate', {
        module: 'WORKORDER',
        ref_id: id // رقم الـ WO
      }, { headers: { 'Authorization': `Bearer ${token}` } });
      
      toast.success(t('wo.messages.wfRouted'));
      loadWO(); // عشان الزرار يختفي للي بدأه ويظهر للي عليه الدور
      fetchWFStatus();
    } catch (err) {
      toast.error(t('wo.messages.wfFail'));
    }
  };

  const fetchWFStatus = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`/api/workflow/check-runtime/WORKORDER/${id}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        setWfContext(res.data);
    } catch (err) {
        console.error("WF Check Failed", err);
    }
};

useEffect(() => {
    if (!isNew) fetchWFStatus();
}, [id, data.status]);

  return (
    <div className={`flex flex-col h-full bg-[#f3f4f6] text-[0.8] overflow-hidden font-bold duration-300 transition-[font-size] ${isRTL ? 'font-cairo' : 'font-sans'}`}  style={{ fontSize: `${fontSize}px` }}>
      <UniversalLookup 
        {...lookup} 
        onClose={() => setLookup({ ...lookup, isOpen: false })} 
        onSelect={handleLookupSelect} 
      />
      {isWFHistoryOpen && (
        <WorkflowHistoryModal 
          module="WORKORDER" 
          refId={id} 
          onClose={() => setIsWFHistoryOpen(false)} 
        />
      )}
      {showStatusModal && (
        <StatusModal 
          currentStatus={data.status}
          recordId={data.wonum}
          appName="WO"
          domainId={data.status === 'APPR' ? 'CANCEL_ONLY' : fieldMaps['status']}
          onClose={() => setShowStatusModal(false)}
          onComplete={async () => {
                await loadData(); 
                
                const event = new CustomEvent('SHOW_CREATE_PO_MENU', { 
                    detail: { prnum: data.wonum, status: 'APPR' } 
                });
                window.dispatchEvent(event);
            }}          
        />)}
        
      {showHistoryModal && (
      <StatusHistoryModal isOpen={showHistoryModal} appName="WO" recordId={data.wonum} onClose={() => setShowHistoryModal(false)} />)}
      {!isNew && (
      <AttachmentsModal 
          isOpen={isDocModalOpen} 
          onClose={() => {setIsDocModalOpen(false);fetchCount();}} 
          ownertable="WO" 
          ownerid={data.wonum} 
      />)}
      {hoveredAsset && (
        <div 
          className="fixed pointer-events-none transition-all duration-75"
          style={{ top: mousePos.y + 15, left: mousePos.x + 15, zIndex: 9999 }}
        >
          <AssetPreviewCard asset={hoveredAsset} />
        </div>
      )}
      {taskStatusConfig.isOpen && (
        <StatusModal 
          currentStatus={taskStatusConfig.currentStatus}
          recordId={taskStatusConfig.taskid} 
          appName="WOTASK" 
          domainId="WOSTATUS" 
          onClose={() => setTaskStatusConfig({ ...taskStatusConfig, isOpen: false })}
          onComplete={async (newStatus) => {
            const newTasks = [...data.tasks];
            newTasks[taskStatusConfig.index].status = newStatus;
            setData({ ...data, tasks: newTasks });
            setTaskStatusConfig({ ...taskStatusConfig, isOpen: false });
            toast.success(`Task ${taskStatusConfig.taskid} status changed to ${newStatus}`);
          }}
        />
      )}

{/* 1. TOP TOOLBAR */}
    <div className="bg-[#1a3353] text-white p-1.5 flex justify-between items-center shadow-lg z-30 px-4">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate('/workorders')} className="p-1.5 hover:bg-white/10 rounded-full transition-colors text-blue-200">
          <ArrowLeft size={18} className={isRTL ? 'rotate-180' : ''}/>
        </button>
        
        {!isNew && (
          <div className={`flex items-center bg-black/20 border border-white/10 rounded-md px-1 py-0.5 gap-1 ${isRTL ? 'flex-row-reverse' : ''}`}>
            <button disabled={!nav.prev} onClick={() => goTo(nav.first)} className="p-1 hover:text-orange-400 disabled:opacity-30"><ChevronLeft size={16} strokeWidth={3} className={isRTL ? 'rotate-180' : ''}/></button>
            <button disabled={!nav.prev} onClick={() => goTo(nav.prev)} className="p-1 hover:text-orange-400 disabled:opacity-30"><ChevronLeft size={16} className={isRTL ? 'rotate-180' : ''}/></button>
            <div className="px-2 text-[10px] font-mono border-x border-white/10 mx-1">
              <span className="text-orange-400">{nav.current_pos}</span> / {nav.total}
            </div>
            <button disabled={!nav.next} onClick={() => goTo(nav.next)} className="p-1 hover:text-orange-400 disabled:opacity-30"><ChevronRight size={16} className={isRTL ? 'rotate-180' : ''}/></button>
            <button disabled={!nav.next} onClick={() => goTo(nav.last)} className="p-1 hover:text-orange-400 disabled:opacity-30"><ChevronRight size={16} strokeWidth={3} className={isRTL ? 'rotate-180' : ''}/></button>
          </div>
        )}
      </div>

      <div className="flex items-center gap-2">
        {((isNew && canCreate) || (!isNew && canUpdate)) && (
        <button onClick={handleSave} className="bg-green-600 hover:bg-green-700 text-white px-4 py-1.5 rounded-sm flex items-center gap-2 text-[11px] transition-all shadow-md uppercase">
          <Save size={14} /> {t('common.save')}
        </button>
        )}
        {wfContext.can_start && !['COMP', 'CANC', 'CLOSED', 'CLOSE', 'CAN'].includes(data.status) && (
            <button onClick={handleRouteWorkflow} className="bg-orange-600 hover:bg-orange-700 text-white border-0 flex items-center gap-2 text-[11px] font-black h-8 shadow-md uppercase">
                <Zap size={14} fill="currentColor" /> {t('wo.actions.routeWorkflow')}
            </button>
          )}
          
        <WorkflowActionModal moduleName="WORKORDER" refId={id} currentStatus={data.status} onActionComplete={loadWO} />
        <button onClick={() => setIsWFHistoryOpen(true)} className="p-2 hover:bg-white/10 rounded text-blue-200" title={t('wo.actions.wfHistory')}><Workflow size={16} className="text-orange-400"/></button>
        <div className="h-6 w-[1px] bg-white/10 mx-1"></div>
        {!isNew && <SmartPrintButton moduleName="WORKORDER" refId={`${data.wonum}`} extraParams={{ location: data.location, report_type: 'GL_SUMMARY' }} />}
        {!isNew && !['COMP', 'CLOSE', 'CAN'].includes(data.status) && (
        <button onClick={handleStatusChangeInitiation} disabled={isReadOnly} className="p-2 hover:bg-white/10 rounded text-blue-200 transition-colors" title={t('common.change_status')}>
          <Tag size={16}/>
        </button>
        )}
        {!isNew && (
        <button onClick={() => setIsDocModalOpen(true)} className="relative p-2 hover:bg-white/10 rounded text-blue-200" title={t('wo.actions.attachments')}>
          <Paperclip size={16} />
          {count > 0 && <span className="absolute top-1 right-1 bg-red-600 text-[8px] w-3.5 h-3.5 rounded-full flex items-center justify-center font-black">{count}</span>}
        </button>
        )}
        {!isNew && (
        <button onClick={handlePrint} className="p-2 hover:bg-white/10 rounded text-blue-200" title={t('wo.actions.printWO')}>
          <Printer size={16} />
        </button>
        )}
        {data.wohazards?.length > 0 && (
          <button onClick={handlePrintSafetySheet} className="p-2 hover:bg-white/10 rounded text-blue-200" title={t('wo.actions.printSafety')}>
            <Printer size={16} />
          </button>
        )}
        {!isNew && (
        <button onClick={() => setShowHistoryModal(true)} className="p-2 hover:bg-white/10 rounded text-blue-200" title={t('wo.actions.history')}>
          <History size={16}/>
        </button>
        )}
        {!isNew && canDelete && (
          <button onClick={handleDelete} className="p-2 text-red-400 hover:bg-red-500/20 rounded transition-colors" title={t('common.delete')}>
            <Trash2 size={16}/>
          </button>
        )}
        <FontControls />
      </div>
    </div>

    {/* 2. DOCUMENT HEADER  */}
    <div className="bg-white border-b border-gray-200 px-6 py-3 flex items-center gap-12 shadow-sm animate-in fade-in slide-in-from-top duration-500">
      <div className="flex flex-col min-w-[120px]">
        <label className="text-[0.8] text-gray-400 font-black uppercase tracking-widest">{t('wo.headers.workOrder')}</label>
        <span className="text-sm font-black text-[#1a3353]">{data.wonum || t('common.new')}</span>
      </div>

      <div className={`flex flex-col flex-1 border-gray-200 px-8 ${isRTL ? 'border-r' : 'border-l'}`}>
        <label className="text-[0.8] text-gray-400 font-black uppercase tracking-widest">{t('wo.fields.description')}</label>
        <input 
          className={`text-sm font-bold text-gray-700 outline-none focus:text-blue-600 bg-transparent w-full ${isRTL ? 'text-right' : ''}`}
          value={data.description}
          onChange={e => setData({...data, description: e.target.value})}
          placeholder={t('wo.placeholders.desc')}
        />
      </div>

      {data.slanum && (
          <div className="bg-orange-50 border-l-4 border-orange-500 p-4 mb-6 flex justify-between items-center shadow-md animate-pulse">
              <div className="flex items-center gap-3">
                  <Clock className="text-orange-600" size={24}/>
                  <div>
                      <p className="text-[0.7] font-black text-orange-400">{t('wo.headers.activeSla')}</p>
                      <p className="text-blue-900 font-black">{data.slanum} - {data.sladescription}</p>
                  </div>
              </div>
              <div className="text-right">
                  <p className="text-[0.6] text-gray-400 font-black">{data.targcompdate ? t('wo.headers.targetRes') : t('wo.headers.targetResp')}</p>
                  <p className="text-red-600 font-black text-sm italic">
                      {new Date(data.targcompdate || data.targstartdate).toLocaleString()}
                  </p>
              </div>
          </div>
      )}
      <div className={`flex flex-col min-w-[100px] border-gray-200 px-8 ${isRTL ? 'border-r' : 'border-l'}`}>
        <label className="text-[0.8] text-gray-400 font-black uppercase tracking-widest">{t('wo.headers.status')}</label>
        <span className={`text-[10px] font-black px-2 py-0.5 rounded-full w-fit mt-1
          ${data.status === 'WAPPR' ? 'bg-orange-100 text-orange-700' : 'bg-green-100 text-green-700'}`}>
          {data.status}
        </span>
      </div>

      <div className={`flex flex-col min-w-[80px] border-gray-200 px-8 ${isRTL ? 'border-r text-left' : 'border-l text-right'}`}>
        <label className="text-[0.8] text-gray-400 font-black uppercase tracking-widest">{t('wo.headers.totalCost')}</label>
        <span className="text-sm font-black text-green-600">{getActualTotal().toLocaleString()} <small className="text-[0.7]">{currency}</small></span>
      </div>
    </div>

    {/* 3. TABS NAVIGATION (التابات بقت أهدى) */}
    <div className="flex bg-white border-b border-gray-100 px-4 overflow-x-auto no-scrollbar">
      {[
        { id: 'Work Order', label: t('wo.tabs.workOrder'), icon: <Briefcase size={13}/> },
        { id: 'Plans', label: t('wo.tabs.plans'), icon: <FileText size={13}/> },
        { id: 'Assignments', label: t('wo.tabs.assignments'), icon: <UserCheck size={13}/> },
        { id: 'Actuals', label: t('wo.tabs.actuals'), icon: <Activity size={13}/> },
        { id: 'Safety', label: t('wo.tabs.safety'), icon: <ShieldAlert size={13}/> },
        { id: 'Failure Reporting', label: t('wo.tabs.failure'), icon: <AlertTriangle size={13}/> }
      ].map(tItem => (
        <button key={tItem.id} onClick={() => setActiveTab(tItem.id)} 
          className={`px-6 py-2.5 flex items-center gap-2 transition-all whitespace-nowrap text-[10px] font-black uppercase tracking-tighter
          ${activeTab === tItem.id ? 'border-b-2 border-[#1a3353] text-[#1a3353]' : 'text-gray-400 hover:text-gray-600'}`}>
          {tItem.icon} {tItem.label}
        </button>
      ))}
    </div>

      {/* Content Area */}
      <div className="flex-1 overflow-y-auto p-4 custom-scrollbar bg-[#f8f9fb]">
        
        {activeTab === 'Work Order' && (
          <div className="grid grid-cols-12 gap-6 max-w-7xl mx-auto animate-in fade-in duration-500">
            <div className="col-span-8 space-y-6">
              <Section title={t('wo.sections.assetDetails')}>
                <div className="grid grid-cols-2 gap-x-12 gap-y-4">
                  <DataField label={t('wo.fields.location')} value={data.location_id} desc={data.location_description} onSearch={() => handleSearch('location_id', t('wo.actions.selectLoc'),'locations')} isRTL={isRTL} />                
                  <DataField label={t('wo.fields.asset')} value={data.assetnum} desc={data.asset_description} onSearch={() => handleSearch('assetnum', t('wo.actions.selectAsset'),'assets')} onMouseEnter={(e) => handleMouseEnter(e, data.assetnum)} onMouseLeave={() => setHoveredAsset(null)} isRTL={isRTL}/>
                  <DataField label={t('wo.fields.workType')} value={data.wo_type} onSearch={() => handleSmartSearch('wo_type', t('wo.actions.selectType'),'DOMAIN')} isRTL={isRTL} />
                  <DataField label={t('wo.fields.safetyCode')} value={data.safetypnum} onSearch={() => handleSmartSearch('safetypnum', t('wo.actions.selectSafety'),'safetyplans')} isRTL={isRTL} />
                  <DataField label={t('wo.fields.supervisor')} value={data.supervisor} onSearch={() => handleSearch('supervisor',t('wo.actions.selectSup'), 'labors')} isRTL={isRTL} />
                  <DataField label={t('wo.fields.failureClass')} value={data.failure_class} onSearch={() => handleSearch('failure_class',t('wo.actions.selectFail'), 'failure-classes')} isRTL={isRTL} />
                </div>
              </Section>
              {/* --- Scheduling Information  --- */}
              <Section title={t('wo.sections.scheduling')}>
                <div className="grid grid-cols-2 gap-x-20 gap-y-6 p-2">
                  
                  {/*  Target & Scheduled */}
                  <div className="space-y-4">
                    <DateField label={t('wo.fields.targStart')} value={data.targstartdate} readOnly={data.slanum ? true : false} onChange={v => setData({...data, targstartdate: v})} hasCalendar isRTL={isRTL} />
                    <DateField label={t('wo.fields.targFinish')} value={data.targcompdate} onChange={v => setData({...data, targcompdate: v})} hasCalendar isRTL={isRTL} />
                    <DateField label={t('wo.fields.schedStart')} value={data.scheddate} onChange={v => setData({...data, scheddate: v})} hasCalendar isRTL={isRTL} />
                    <DateField label={t('wo.fields.schedFinish')} value={data.schedfinish} onChange={v => setData({...data, schedfinish: v})} hasCalendar isRTL={isRTL} />
                    <DateField label={t('wo.fields.earlyStart')} value={data.earlystart} onChange={v => setData({...data, earlystart: v})} hasCalendar isRTL={isRTL} />
                    <DateField label={t('wo.fields.lateFinish')} value={data.latefinish} onChange={v => setData({...data, latefinish: v})} hasCalendar isRTL={isRTL} />
                  </div>
        
                  {/*  Actuals & Duration */}
                  <div className="space-y-4">
                    <DateField label={t('wo.fields.actStart')} value={data.actstart} onChange={v => setData({...data, actstart: v})} hasCalendar isRTL={isRTL} />
                    <DateField label={t('wo.fields.actFinish')} value={data.actfinish} onChange={v => setData({...data, actfinish: v})} hasCalendar isRTL={isRTL} />
                    
                    <div className="flex items-center gap-4 border-b border-gray-200 pb-1">
                       <div className="flex-1">
                          <EditableField label={`* ${t('wo.fields.duration')}`} value={data.duration} type="text" placeholder="0:00" onChange={v => setData({...data, estdur: v})} isHighlight isRTL={isRTL} />
                       </div>
                       <div className="text-[9px] text-gray-700 font-bold self-end pb-1">{t('hrs')}</div>
                    </div>
        
                    <EditableField label={t('wo.fields.timeRemaining')} value={data.timeremaining} readOnly />
                    <DataField label={t('wo.fields.predecessors')} value={data.predecessors} onSearch={() => handleSmartSearch('predecessors', 'Predecessors', 'wo')} />
                    
                    <div className="flex items-center gap-2 pt-2">
                      <input 
                        type="checkbox" 
                        checked={data.include_tasks_in_sched || false} 
                        onChange={(e) => setData({...data, include_tasks_in_sched: e.target.checked})} 
                        className="w-4 h-4 rounded accent-blue-600 cursor-pointer" 
                      />
                      <span className="font-bold text-blue-900 uppercase text-[10px]">{t('wo.fields.includeTasks')}</span>
                    </div>
                  </div>
        
                </div>
              </Section>

            </div>
            <div className="col-span-4">
              <Section title={t('wo.sections.responsibility')}>
                <div className="space-y-4">
                  <DataField label={t('wo.fields.site')} value={data.site_id} />
                  <DataField label={t('wo.fields.organization')} value={data.org_id} />
                  <div className="p-4 bg-orange-50 border border-orange-200 rounded-lg text-orange-800 text-[10px] font-bold uppercase">
                     <EditableField label={t('wo.fields.priorityHigh')} value={data.priority} />
                  </div>
                </div>
              </Section>
            </div>
          </div>
        )}

        {activeTab === 'Plans' && (
          <div className="max-w-7xl mx-auto bg-white rounded shadow-xl overflow-hidden animate-in slide-in-from-bottom duration-300 min-h-[500px] flex flex-col">
            {/* Sub-Tabs Header */}
            <div className="flex bg-gray-50 border-b shadow-inner">
              {['Tasks', 'Labor', 'Materials', 'Tools'].map(st => (
                <button key={st} onClick={() => setPlanSubTab(st)} 
                  className={`px-10 py-3 text-[0.9] font-black uppercase transition-all
                  ${planSubTab === st ? 'bg-white border-t-4 border-t-blue-900 text-blue-900' : 'text-gray-700 hover:text-blue-700'}`}>
                  {t(`wo.subTabs.${st.toLowerCase()}`)}
                </button>
              ))}
            </div>
        
            {/* Sub-Tabs Content */}
            <div className="p-4 flex-1 bg-white overflow-y-auto custom-scrollbar">
              
              {/* 1. Tasks Section */}
              {planSubTab === 'Tasks' && (
                <div className="animate-in fade-in duration-300">
                  <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                    <thead className="bg-slate-50 text-gray-700 text-[0.8e] uppercase border-b font-black">
                      <tr>
                        <th className="p-2 border-r w-20 text-center">{t('wo.tables.sequence')}</th>
                        <th className="p-2 border-r text-left">{t('wo.tables.taskDesc')}</th>
                        <th className="p-2 border-r w-24 text-center">{t('wo.tables.estDur')}</th>
                        <th className="p-2 border-r w-24 text-center">{t('wo.tables.status')}</th>
                        <th className="p-2 w-10 text-center text-red-500"><Tag size={12}/></th>                                    
                        <th className="p-2 w-10 text-center text-red-500"><Trash2 size={12}/></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {data.tasks.map((row, idx) => (
                        <tr key={idx} className="hover:bg-blue-50/30 transition-colors">
                          <td className="p-2 border-r text-center font-bold text-blue-900">{row.wosequence}</td>
                          <td className="p-2 border-r">
                            <input className="w-full outline-none bg-transparent font-semibold uppercase" value={row.description} 
                                   onChange={e => updateRow('tasks', idx, 'description', e.target.value)} />
                          </td>
                          <td className="p-2 border-r">
                            <input type="number" className="w-full outline-none bg-transparent text-center font-mono" value={row.estdur} 
                                   onChange={e => updateRow('tasks', idx, 'estdur', e.target.value)} />
                          </td>
                          <td className="p-2 border-r">
                            <input className="w-full outline-none bg-transparent text-center font-mono" value={row.status} 
                                   onChange={e => updateRow('tasks', idx, 'status', e.target.value)} disabled />
                          </td>
                          <td className="p-2 text-center">
                            <button onClick={(e) => {e.stopPropagation(); handleTaskStatusClick(row, idx)}} className="text-gray-300 hover:text-red-500"><Tag size={14}/></button>
                          </td>                                               
                          <td className="p-2 text-center">
                            <button onClick={() => removeRow('tasks', idx)} className="text-gray-300 hover:text-red-500"><Trash2 size={14}/></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button onClick={addTaskRow} className="mt-4 bg-blue-900 text-white px-6 py-2 rounded-sm flex items-center gap-2 text-[9px] font-black hover:bg-black uppercase shadow-md transition-all">
                    <Plus size={14}/> {t('wo.actions.newTask')}
                  </button>
                </div>
              )}
        
              {/* 2. Labor Section */}
              {planSubTab === 'Labor' && (
                <div className="animate-in fade-in duration-300">
                  <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                    <thead className="bg-slate-50 text-gray-700 text-[0.8] uppercase border-b font-black">
                      <tr>
                        <th className="p-2 border-r text-left w-32">{t('wo.tables.craft')}</th>
                        <th className="p-2 border-r text-left w-32">{t('wo.tables.labor')}</th>                        
                        <th className="p-2 border-r w-16 text-center">{t('wo.tables.qty')}</th>
                        <th className="p-2 border-r w-16 text-center">{t('wo.tables.hrs')}</th>
                        <th className="p-2 border-r w-24 text-center">{t('wo.tables.rate')}</th>
                        <th className="p-2 border-r w-28 text-center bg-blue-50/50">{t('wo.tables.lineCost')}</th>
                        <th className="p-2 w-10 text-center text-red-500"><Trash2 size={12}/></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {data.planned_labor.map((row, idx) => (
                        <tr key={idx} className="hover:bg-blue-50/30 transition-colors">
                          <td className="p-2 border-r">
                            <div className="flex justify-between items-center group">
                              <span className="font-black text-blue-900 uppercase">{row.craft || 'SELECT'}</span>
                              <Search size={12} className="text-blue-500 cursor-pointer" onClick={() => handleSearch('row_plan_craft', 'Select Craft', 'crafts', idx)} onChange={e => updateRow('planned_labor', idx, 'craft', e.target.value)} />
                            </div>
                          </td>
                          <td className="p-2 border-r">
                            <div className="flex justify-between items-center group">
                              <span className="font-black text-blue-900 uppercase">{row.laborcode || 'SELECT'}</span>
                              <Search size={12} className="text-blue-500 cursor-pointer" onClick={() => handleSearch('row_plan_labor', 'Select Labor', 'labors', idx)} onChange={e => updateRow('planned_labor', idx, 'laborcode')} />
                            </div>
                          </td>                          
                          <td className="p-2 border-r"><input type="number" className="w-full text-center outline-none bg-transparent" value={row.quantity} onChange={e => updateRow('planned_labor', idx, 'quantity', e.target.value)} /></td>
                          <td className="p-2 border-r"><input type="number" className="w-full text-center outline-none bg-transparent" value={row.laborhrs} onChange={e => updateRow('planned_labor', idx, 'laborhrs', e.target.value)} /></td>
                          <td className="p-2 border-r text-center text-gray-700 font-mono italic">{row.laborrate}</td>
                          <td className="p-2 border-r text-center font-black text-green-700 bg-blue-50/20">{Number(row.linecost).toLocaleString()}</td>
                          <td className="p-2 text-center">
                            <button onClick={() => removeRow('planned_labor', idx)} className="text-gray-300 hover:text-red-500"><Trash2 size={14}/></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button onClick={addLaborRow} className="mt-4 bg-blue-900 text-white px-6 py-2 rounded-sm flex items-center gap-2 text-[9px] font-black hover:bg-black uppercase shadow-md transition-all">
                    <Plus size={14}/> {t('wo.actions.addLabor')}
                  </button>
                </div>
              )}
        
              {/* 3. Materials Section */}
              {planSubTab === 'Materials' && (
                <div className="animate-in fade-in duration-300">
                  <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                    <thead className="bg-slate-50 text-gray-700 text-[0.8] uppercase border-b font-black">
                      <tr>
                        <th className="p-2 border-r text-left w-24">{t('wo.tables.lineType')}</th>
                        <th className="p-2 border-r text-left w-32">{t('wo.tables.itemNum')}</th>
                        <th className="p-2 border-r text-left">{t('wo.tables.description')}</th>
                        <th className="p-2 border-r w-20 text-center">{t('wo.tables.qty')}</th>
                        <th className="p-2 border-r w-24 text-center">{t('wo.tables.unitCost')}</th>
                        <th className="p-2 border-r w-28 text-center bg-blue-50/50 text-blue-900">{t('wo.tables.lineCost')}</th>
                        <th className="p-2 border-r text-left w-32 text-orange-800">{t('wo.tables.storeroom')}</th>
                        <th className="p-2 w-10 text-center text-red-500"><Trash2 size={12}/></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {data.planned_materials.map((row, idx) => (
                        <tr key={idx} className="hover:bg-blue-50/30 transition-colors">
                          <td className="p-2 border-r">
                            <select className="w-full bg-transparent outline-none font-bold text-blue-900 uppercase" value={row.linetype} onChange={e => updateMaterialRow(idx, 'linetype', e.target.value)}>
                              <option value="ITEM">{t('wo.tables.item')}</option>
                              <option value="MATERIAL">{t('wo.tables.material')}</option>
                            </select>
                          </td>
                          <td className="p-2 border-r font-black text-blue-900">
                            <div className="flex justify-between items-center group">
                              <span>{row.itemnum || '---'}</span>
                              <Search size={12} className="text-blue-500 cursor-pointer" onClick={() => handleSearch('row_plan_item', 'Select Item', 'items', idx)} />
                            </div>
                          </td>
                          <td className="p-2 border-r text-gray-500 italic font-medium">{row.description}</td>
                          <td className="p-2 border-r"><input type="number" className="w-full text-center outline-none bg-transparent" value={row.quantity} onChange={e => updateMaterialRow(idx, 'quantity', e.target.value)} /></td>
                          <td className="p-2 border-r"><input type="number" className="w-full text-center outline-none bg-transparent font-mono" value={row.unitcost} onChange={e => updateMaterialRow(idx, 'unitcost', e.target.value)} /></td>
                          <td className="p-2 border-r text-center font-black text-green-700 bg-blue-50/20">{Number(row.linecost).toLocaleString()}</td>
                          <td className="p-2 border-r">
                            <div className="flex justify-between items-center group">
                              <span className="text-orange-900 font-bold uppercase">{row.fromstore || '---'}</span>
                              <Search size={12} className="text-orange-400 cursor-pointer" onClick={() => handleSearch('row_plan_store', 'Select Store', 'storerooms', idx)} />
                            </div>
                          </td>
                          <td className="p-2 text-center">
                            <button onClick={() => removeRow('planned_materials', idx)} className="text-gray-300 hover:text-red-500"><Trash2 size={14}/></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button onClick={addMaterialRow} className="mt-4 bg-blue-900 text-white px-6 py-2 rounded-sm flex items-center gap-2 text-[9px] font-black hover:bg-black uppercase shadow-md transition-all">
                    <Plus size={14}/> {t('wo.actions.addMaterial')}
                  </button>
                </div>
              )}
        
              {/* 4. Tools Section */}
              {planSubTab === 'Tools' && (
                <div className="animate-in fade-in duration-300">
                  <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                    <thead className="bg-slate-50 text-gray-700 text-[0.8] uppercase border-b font-black">
                      <tr>
                        <th className="p-2 border-r text-left w-32">{t('wo.tables.toolNum')}</th>
                        <th className="p-2 border-r text-left">{t('wo.tables.description')}</th>
                        <th className="p-2 border-r w-20 text-center">{t('wo.tables.hrs')}</th>
                        <th className="p-2 border-r w-24 text-center">{t('wo.tables.rate')}</th>
                        <th className="p-2 border-r w-28 text-center bg-blue-50/50">{t('wo.tables.lineCost')}</th>
                        <th className="p-2 w-10 text-center text-red-500"><Trash2 size={12}/></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {data.planned_tools?.map((row, idx) => (
                        <tr key={idx} className="hover:bg-blue-50/30 transition-colors">
                          <td className="p-2 border-r font-black text-blue-900 uppercase">
                            <div className="flex justify-between items-center group">
                              <span>{row.itemnum || '---'}</span>
                              <Search size={12} className="text-blue-500 cursor-pointer" onClick={() => handleSearch('row_plan_tool', 'Select Tool', 'tools', idx)} />
                            </div>
                          </td>
                          <td className="p-2 border-r text-gray-500 font-semibold italic">{row.description}</td>
                          <td className="p-2 border-r"><input type="number" className="w-full text-center outline-none bg-transparent" value={row.hours} onChange={e => updateToolRow(idx, 'hours', e.target.value)} /></td>
                          <td className="p-2 border-r text-center font-mono text-gray-700 italic">{row.toolrate}</td>
                          <td className="p-2 border-r text-center font-black text-green-700 bg-blue-50/20">{Number(row.linecost).toLocaleString()}</td>
                          <td className="p-2 text-center">
                            <button onClick={() => removeRow('planned_tools', idx)} className="text-gray-300 hover:text-red-500"><Trash2 size={14}/></button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button onClick={addToolRow} className="mt-4 bg-[#1a3353] text-white px-6 py-2 rounded-sm flex items-center gap-2 text-[9px] font-black hover:bg-black uppercase shadow-md transition-all">
                    <Plus size={14}/> {t('wo.actions.addTool')}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
        {activeTab === 'Assignments' && (
          <div className="max-w-7xl mx-auto bg-white rounded shadow-xl overflow-hidden animate-in slide-in-from-bottom duration-300 min-h-[500px] flex flex-col">
            <div className="p-4 bg-slate-50 border-b flex justify-between items-center">
              <h3 className="text-blue-900 font-black uppercase text-[0.9] tracking-widest flex items-center gap-2">
                <UserCheck size={16}/> {t('wo.sections.laborAssign')}
              </h3>
              <span className="text-[0.9] bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full font-bold">
                {t('wo.sections.totalAssign')} : {data.assignments.length}
              </span>
            </div>
        
            <div className="p-4 flex-1 overflow-x-auto">
              <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                <thead className="bg-slate-50 text-gray-700 text-[0.8] uppercase border-b font-black">
                  <tr>
                    <th className={`p-2 border-x w-32 ${isRTL ? 'border-l text-right' : 'border-r text-left'}`}>{t('wo.tables.craft')}</th>
                    <th className={`p-2 border-x w-32 ${isRTL ? 'border-l text-right' : 'border-r text-left'}`}>{t('wo.tables.labor')}</th>
                    <th className={`p-2 border-x ${isRTL ? 'border-l text-right' : 'border-r text-left'}`}>{t('wo.tables.description')}</th>
                    <th className={`p-2 border-x w-16 text-center ${isRTL ? 'border-l' : 'border-r'}`}>{t('wo.tables.qty')}</th>
                    <th className={`p-2 border-x w-16 text-center ${isRTL ? 'border-l' : 'border-r'}`}>{t('wo.tables.hrs')}</th>
                    <th className={`p-2 border-x w-20 text-center ${isRTL ? 'border-l' : 'border-r'}`}>{t('wo.tables.rate')}</th>
                    <th className={`p-2 border-x w-24 text-center bg-blue-50/50 ${isRTL ? 'border-l' : 'border-r'}`}>{t('wo.tables.lineCost')}</th>
                    <th className={`p-2 border-x w-24 text-center ${isRTL ? 'border-l' : 'border-r'}`}>{t('wo.tables.status')}</th>
                    <th className="p-2 w-10 text-center text-red-500"><CheckCircle size={12}/></th>
                    <th className="p-2 w-10 text-center text-red-500"><Trash2 size={12}/></th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {data.assignments.map((row, idx) => (
                    <tr key={idx} className="hover:bg-blue-50/30 transition-colors text-[10px]">
                      {/* Craft Selection */}
                      <td className="p-2 border-r">
                        <div className="flex justify-between items-center group">
                          <span className="font-black text-blue-900 uppercase">{row.craft || 'SELECT'}</span>
                          <Search size={12} className="text-blue-500 cursor-pointer" 
                            onClick={() => handleSearch('row_assign_craft', 'Select Craft', 'crafts', idx)} />
                        </div>
                      </td>
                      {/* Labor Selection */}
                      <td className="p-2 border-r">
                        <div className="flex justify-between items-center group">
                          <span className="font-black text-blue-900 uppercase">{row.laborcode || 'SELECT'}</span>
                          <Search size={12} className="text-blue-500 cursor-pointer" 
                            onClick={() => handleSearch('row_assign_labor', 'Select Labor', 'labors', idx)} />
                        </div>
                      </td>
                      {/* Description */}
                      <td className="p-2 border-r">
                        <input className="w-full outline-none bg-transparent font-semibold uppercase" 
                          value={row.description} placeholder="TASK DESCRIPTION..."
                          onChange={e => updateAssignmentRow(idx, 'description', e.target.value)} />
                      </td>
                      {/* Quantity & Hours */}
                      <td className="p-2 border-r">
                        <input type="number" className="w-full text-center outline-none bg-transparent" 
                          value={row.quantity} onChange={e => updateAssignmentRow(idx, 'quantity', e.target.value)} />
                      </td>
                      <td className="p-2 border-r">
                        <input type="number" className="w-full text-center outline-none bg-transparent font-mono" 
                          value={row.laborhrs} onChange={e => updateAssignmentRow(idx, 'laborhrs', e.target.value)} />
                      </td>
                      {/* Rate & Line Cost */}
                      <td className="p-2 border-r text-center text-gray-500 font-mono italic">{row.laborrate}</td>
                      <td className="p-2 border-r text-center font-black text-green-700 bg-blue-50/20">
                        {Number(row.linecost).toLocaleString()}
                      </td>
                      {/* Status */}
                      <td className="p-2 border-r text-center font-bold text-orange-600 uppercase italic">
                        {row.status}
                      </td>
                      {/* Complet */}
                      <td className="p-2 text-center">
                        {row.status !== 'COMPLETED' && (
                            <button 
                              onClick={() => handleCompleteAssignment(idx)}
                              className="p-1 hover:bg-green-50 rounded-full transition-all group"
                              title="Complete Assignment"
                            >
                              <CheckCircle size={15} className="text-slate-300 group-hover:text-green-600" />
                            </button>
                          )}                      
                      </td>
                      {/* Actions */}
                      <td className="p-2 text-center">
                        <button onClick={() => removeRow('assignments', idx)} className="text-gray-300 hover:text-red-500">
                          <Trash2 size={14}/>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
        
              {data.assignments.length === 0 && (
                <div className="flex flex-col items-center justify-center p-20 text-gray-300">
                  <UserCheck size={48} className="opacity-20 mb-2" />
                  <p className="italic">{t('wo.messages.noLaborAssign')}</p>
                </div>
              )}
        
              <button onClick={addAssignmentRow} className="mt-4 bg-blue-900 text-white px-6 py-2 rounded-sm flex items-center gap-2 text-[9px] font-black hover:bg-black uppercase shadow-md transition-all">
                <Plus size={14}/> {t('wo.actions.newAssign')}
              </button>
            </div>
          </div>
        )}
        
            {/* 2. Actuals Content Area */}
            {activeTab === 'Actuals' && (
              <div className="max-w-7xl mx-auto bg-white rounded shadow-2xl overflow-hidden animate-in slide-in-from-right duration-500 min-h-[650px] flex flex-col border border-slate-200">
                
                {/* 1. Actuals Sub-Tabs Header */}
                <div className="flex bg-slate-50 border-b border-slate-200 sticky top-0 z-10">
                  {['Tasks', 'Labor', 'Materials', 'Tools', 'Services'].map((st) => (
                    <button
                      key={st}
                      onClick={() => setActualSubTab(st)}
                      className={`px-10 py-4 text-[0.8] font-black uppercase tracking-wider transition-all
                      ${actualSubTab === st 
                        ? 'bg-white text-green-700 border-t-4 border-t-green-600 shadow-sm' 
                        : 'text-slate-400 hover:text-green-600 hover:bg-slate-100'}`}
                    >
                      {t(`wo.subTabs.${st.toLowerCase()}`)}
                    </button>
                  ))}
                </div>
            
                {/* 2. Actuals Content Area */}
                <div className="p-6 flex-1 overflow-y-auto custom-scrollbar bg-white">
                  
                  {/* ���� عرض التاسكات اللي جاية من البلانز أوتوماتيك */}
                  {actualSubTab === 'Tasks' && (
                    <div className="animate-in fade-in duration-300">
                      <p className="text-[10px] text-gray-700 mb-4 italic uppercase">{t('wo.messages.updateTaskProg')}</p>
                      <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                        <thead className="bg-slate-100 text-slate-500 text-[0.8] uppercase font-black border-b">
                          <tr>
                            <th className="p-3 text-left w-20">{t('wo.tables.sequence')}</th>
                            <th className="p-3 text-left">{t('wo.tables.taskDesc')}</th>
                            <th className="p-3 text-center w-32">{t('wo.tables.status')}</th>
                            <th className="p-3 w-10"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.tasks?.map((row, idx) => (
                            <tr key={idx} className="border-b border-slate-50 hover:bg-green-50/20">
                              <td className="p-3 font-bold text-slate-400">{row.wosequence}</td>
                              <td className="p-3 text-slate-700 font-semibold">{row.description}</td>
                              <td className="p-3 text-center">
                                <button onClick={() => handleTaskStatusClick(row, idx)} className={`px-4 py-1 rounded-full text-[10px] font-black uppercase border-2 transition-all ${row.status === 'COMP' ? 'bg-green-600 border-green-600 text-white' : 'border-green-600 text-green-600 hover:bg-green-600 hover:text-white'}`}>
                                  {row.status}
                                </button>
                              </td>
                              <td className="p-3 text-center"><Trash2 size={14} className="text-slate-200 cursor-not-allowed" /></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
            
                  {/* Actual Labor */}
                  {actualSubTab === 'Labor' && (
                    <div className="animate-in fade-in duration-300">
                      <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                        <thead className="bg-[#1a3353] text-white text-[0.8] uppercase font-black">
                          <tr>
                            <th className="p-2 text-left">{t('wo.tables.labor')}</th>
                            <th className="p-2 text-center w-44">{t('wo.tables.start')}</th>
                            <th className="p-2 text-center w-44">{t('wo.tables.finish')}</th>
                            <th className="p-2 text-center w-16 bg-blue-800">{t('wo.tables.hrs')}</th>
                            <th className="p-2 text-center w-24">{t('wo.tables.rate')}</th>
                            <th className="p-2 text-center w-32 bg-green-700">{t('wo.tables.cost')}</th>
                            <th className="p-2 w-8"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.actual_labor?.map((row, idx) => (
                            <tr key={idx} className="border-b hover:bg-green-50/30 text-[0.9]">
                              <td className="p-2 border-r font-bold text-blue-900 flex justify-between items-center uppercase">
                                {row.laborcode || '---'} <Search size={12} className="cursor-pointer text-blue-500" onClick={() => handleSearch('row_act_labor', 'Labor', 'labors', idx)}/>
                              </td>
                              <td className="p-2 border-r text-center"><input type="datetime-local" className="bg-transparent outline-none" value={formatDateTime(row.startdate)} onChange={e => updateActualLaborRow(idx, 'startdate', e.target.value)} /></td>
                              <td className="p-2 border-r text-center"><input type="datetime-local" className="bg-transparent outline-none" value={formatDateTime(row.finishdate)} onChange={e => updateActualLaborRow(idx, 'finishdate', e.target.value)} /></td>
                              <td className="p-2 border-r text-center font-black text-blue-600">{row.regularhrs || 0}</td>
                              <td className="p-2 border-r text-center italic">{row.laborrate}</td>
                              <td className="p-2 border-r text-center font-black text-green-700">{Number(row.linecost || 0).toLocaleString()}</td>
                              <td className="p-2 text-center"><Trash2 size={12} className="text-red-400 cursor-pointer" onClick={() => removeRow('actual_labor', idx)}/></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <button onClick={() => addRow('actual_labor')} className="mt-4 bg-green-600 text-white px-6 py-2 rounded-sm text-[9px] font-black uppercase shadow-md"><Plus size={14}/> {t('wo.actions.addLabor')}</button>
                    </div>
                  )}
            
                  {/* Actual Materials */}
                  {actualSubTab === 'Materials' && (
                    <div className="animate-in fade-in duration-300">
                      <div className="border rounded-sm overflow-hidden bg-white">
                        <table className={`w-full table-fixed border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                          <thead className="bg-slate-100 text-slate-500 text-[0.8] uppercase font-black border-b">
                            <tr>
                              <th className="p-2 border-r text-left w-[30%]">{t('wo.tables.itemNum')}</th>
                              <th className="p-2 border-r text-left w-[30%] text-orange-700">{t('wo.tables.storeroom')}</th>
                              <th className="p-2 border-r text-center w-[15%]">{t('wo.tables.qty')}</th>
                              <th className="p-2 border-r text-center w-[15%] bg-green-50/50">{t('wo.tables.lineCost')}</th>
                              <th className="p-2 w-[10%]"></th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-slate-100">
                            {data.actual_materials?.map((row, idx) => (
                              <tr key={idx} className="hover:bg-slate-50 transition-colors text-[10px]">
                                {/* Item Column */}
                                <td className="p-2 border-r">
                                  <div className="flex justify-between items-center bg-gray-50/50 px-2 py-1 rounded-sm border border-transparent hover:border-blue-300 transition-all">
                                    <span className="font-bold text-slate-800 truncate">{row.itemnum || '---'}</span>
                                    <Search 
                                      size={14} 
                                      className="text-blue-500 cursor-pointer hover:scale-110 shrink-0 ml-1" 
                                      onClick={() => handleSearch('row_act_item', 'Select Item', 'items', idx)}
                                    />
                                  </div>
                                </td>
                  
                                {/* Storeroom Column */}
                                <td className="p-2 border-r">
                                  <div className="flex justify-between items-center bg-orange-50/30 px-2 py-1 rounded-sm border border-transparent hover:border-orange-300 transition-all text-orange-900">
                                    <span className="font-black truncate">{row.fromstore || 'SELECT STORE'}</span>
                                    <Search 
                                      size={14} 
                                      className="text-orange-400 cursor-pointer hover:scale-110 shrink-0 ml-1" 
                                      onClick={() => handleSearch('row_act_store', 'Select Store', 'storerooms', idx)}
                                    />
                                  </div>
                                </td>
                  
                                {/* Quantity Column */}
                                <td className="p-2 border-r text-center">
                                  <input 
                                    type="number" 
                                    className="w-full bg-transparent text-center font-black text-blue-600 outline-none focus:ring-1 focus:ring-blue-400 rounded-sm" 
                                    value={row.quantity} 
                                    onChange={e => updateActualMaterialRow(idx, 'quantity', e.target.value)} 
                                  />
                                </td>
                  
                                {/* Line Cost Column */}
                                <td className="p-2 border-r text-center bg-green-50/20">
                                  <span className="font-black text-green-700">{Number(row.linecost || 0).toLocaleString()}</span>
                                </td>
                  
                                {/* Action Column */}
                                <td className="p-2 text-center">
                                  <button 
                                    onClick={() => handleCreateMR(row)}
                                    className="p-1 hover:bg-orange-50 rounded-full transition-colors group/mr"
                                    title="Create Material Request (MR)"
                                  >
                                    <FileText size={14} className="text-slate-300 group-hover/mr:text-orange-600" />
                                  </button>
                                  <button 
                                    onClick={() => removeRow('actual_materials', idx)} 
                                    className="p-1 hover:bg-red-50 rounded-full transition-colors group"
                                  >
                                    <Trash2 size={14} className="text-slate-300 group-hover:text-red-500" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                  
                      {data.actual_materials.length === 0 && (
                        <div className="text-center p-12 border-2 border-dashed border-slate-100 rounded-sm mt-2">
                          <span className="text-slate-300 italic text-[0.8]">{t('wo.messages.noMaterials')}</span>
                        </div>
                      )}
                      {/* عرض حالة الـ MRs المرتبطة */}
                      <div className="mt-6 border-t pt-4">
                        <h4 className="text-[0.9em] font-black text-slate-500 uppercase mb-3 flex items-center gap-2">
                          <List size={14}/> {t('wo.messages.linkedMRs')}
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          {/* لو عندك لستة بالـ MRs المفتوحة في الداتا */}
                          {data.related_mrs?.map((mr, i) => (
                            <div key={i} className="bg-white border-l-4 border-l-orange-500 p-2 shadow-sm flex justify-between items-center">
                              <div>
                                <p className="text-[10px] font-black text-blue-900">{mr.mrnum}</p>
                                <p className="text-[9px] text-gray-500">{mr.description}</p>
                              </div>
                              <span className="bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full text-[8px] font-black">
                                {mr.status}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                      <button 
                        onClick={() => addRow('actual_materials')} 
                        className="mt-4 bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-sm text-[10px] font-black uppercase shadow-sm flex items-center gap-2 transition-transform active:scale-95"
                      >
                        <Plus size={14} strokeWidth={3}/> {t('wo.actions.addMaterial')}
                      </button>
                    </div>
                  )}
            
                  {/* Actual Tools */}
                  {actualSubTab === 'Tools' && (
                    <div className="animate-in fade-in duration-300">
                      <table className={`w-full border-collapse ${isRTL ? 'text-right' : 'text-left'}`}>
                        <thead className="bg-slate-100 text-slate-500 text-[0.8] uppercase font-black border-b">
                          <tr><th className="p-3 text-left">{t('wo.tables.toolNum')}</th><th className="p-3 text-center w-32">{t('wo.tables.hrs')}</th><th className="p-3 text-center w-32">{t('wo.tables.rate')}</th><th className="p-3 text-center w-32 bg-green-50">Cost</th><th className="p-3 w-10"></th></tr>
                        </thead>
                        <tbody>
                          {data.actual_tools?.map((row, idx) => (
                            <tr key={idx} className="border-b border-slate-50 text-[10px]">
                              <td className="p-3 border-r font-bold flex justify-between uppercase">{row.toolnum || '---'}<Search size={14} className="cursor-pointer" onClick={() => handleSearch('row_act_tool', 'Tool', 'tools', idx)}/></td>
                              <td className="p-3 border-r text-center"><input type="number" className="w-16 text-center" value={row.hours} onChange={e => updateRow('actual_tools', idx, 'hours', e.target.value)} /></td>
                              <td className="p-3 border-r text-center font-mono">{row.toolrate}</td>
                              <td className="p-3 border-r text-center font-black text-green-700">{Number(row.linecost || 0).toLocaleString()}</td>
                              <td className="p-3 text-center"><Trash2 size={14} className="text-red-400 cursor-pointer" onClick={() => removeRow('actual_tools', idx)}/></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <button onClick={() => addRow('actual_tools')} className="mt-4 bg-green-600 text-white px-6 py-2 rounded-sm text-[9px] font-black uppercase shadow-md"><Plus size={14}/> {t('wo.actions.addTool')}</button>
                    </div>
                  )}
            
                  {/* Actual Services */}
                  {actualSubTab === 'Services' && (
                    <div className="animate-in fade-in duration-300">
                      <table className={`w-full border-collapse border ${isRTL ? 'text-right' : 'text-left'}`}>
                        <thead className="bg-slate-100 text-slate-500 text-[0.8] font-black border-b">
                          <tr><th className="p-3 text-left">{t('wo.tables.serviceDesc')}</th><th className="p-3 text-left">{t('wo.tables.vendor')}</th><th className="p-3 text-center w-32">{t('wo.tables.cost')}</th><th className="p-3 w-10"></th></tr>
                        </thead>
                        <tbody>
                          {data.actual_services?.map((row, idx) => (
                            <tr key={idx} className="border-b text-[10px]">
                              <td className="p-3 border-r"><input className="w-full outline-none uppercase" value={row.description} onChange={e => updateRow('actual_services', idx, 'description', e.target.value)} /></td>
                              <td className="p-3 border-r font-black"><div className="flex justify-between">{row.vendor || '---'}<Search size={14} className="cursor-pointer text-blue-500" /></div></td>
                              <td className="p-3 border-r text-center font-black text-green-700"><input type="number" className="w-24 text-center" value={row.linecost} onChange={e => updateRow('actual_services', idx, 'linecost', e.target.value)} /></td>
                              <td className="p-3 text-center"><Trash2 size={14} className="text-red-400 cursor-pointer" onClick={() => removeRow('actual_services', idx)}/></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <button onClick={() => addRow('actual_services')} className="mt-4 bg-green-600 text-white px-6 py-2 rounded-sm text-[9px] font-black uppercase shadow-md"><Plus size={14}/> {t('wo.actions.addService')}</button>
                    </div>
                  )}
                </div>
            
                {/* Summary Footer */}
                {/* إضافة قسم الـ Assignments في الفوتر لإظهار التكلفة المحجوزة */}
                {/* شريط ملخص التكاليف (Summary Footer) */}
                <div className="bg-[#0f172a] text-white p-5 flex justify-around items-center border-t border-slate-700 shadow-2xl z-10">
                    
                    {/* 1. تكلفة العمالة الفعلية */}
                    <div className="flex flex-col items-center">
                        <span className="text-[9px] text-slate-400 font-bold uppercase mb-1 tracking-tighter">{t('wo.footer.totalLabor')}</span>
                        <span className="text-lg font-black text-blue-400">
                            {data.actual_labor?.reduce((sum, r) => sum + Number(r.linecost || 0), 0).toLocaleString()}
                        </span>
                    </div>
                
                    <div className="w-[1px] h-10 bg-slate-700"></div>
                
                    {/* 2. تكلفة المواد الفعلية */}
                    <div className="flex flex-col items-center">
                        <span className="text-[9px] text-slate-400 font-bold uppercase mb-1 tracking-tighter">{t('wo.footer.totalMaterial')}</span>
                        <span className="text-lg font-black text-orange-400">
                            {data.actual_materials?.reduce((sum, r) => sum + Number(r.linecost || 0), 0).toLocaleString()}
                        </span>
                    </div>
                
                    <div className="w-[1px] h-10 bg-slate-700"></div>
                
                    {/* 3. التكلفة المحجوزة (Assignments) - باللون الأصفر كما اتفقنا */}
                    <div className="flex flex-col items-center">
                        <span className="text-[9px] text-yellow-500/80 font-bold uppercase mb-1 tracking-tighter text-center">
                            {t('wo.footer.assigned')}
                        </span>
                        <span className="text-lg font-black text-yellow-500">
                            {data.assignments?.reduce((sum, r) => sum + Number(r.linecost || 0), 0).toLocaleString()}
                        </span>
                    </div>
                
                    <div className="w-[1px] h-10 bg-slate-700"></div>
                
                    {/* 4. تكلفة الأدوات والخدمات (Other) */}
                    <div className="flex flex-col items-center">
                        <span className="text-[9px] text-slate-400 font-bold uppercase mb-1 tracking-tighter">{t('wo.footer.toolsServ')}</span>
                        <span className="text-lg font-black text-purple-400">
                            {(
                                (data.actual_tools?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0) +
                                (data.actual_services?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0)
                            ).toLocaleString()}
                        </span>
                    </div>
                
                    <div className="w-[1px] h-10 bg-slate-700"></div>
                
                    {/* 5. الإجمالي النهائي (Actual Order Cost) */}
                    <div className="flex flex-col items-center bg-green-500/10 px-6 py-2 rounded-lg border border-green-500/20">
                        <span className="text-[9px] text-green-400 font-bold uppercase mb-1 tracking-widest">{t('wo.footer.totalActual')}</span>
                        <span className="text-xl font-black text-green-500">
                            {(
                                (data.actual_labor?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0) +
                                (data.actual_materials?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0) +
                                (data.actual_tools?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0) +
                                (data.actual_services?.reduce((sum, r) => sum + Number(r.linecost || 0), 0) || 0)
                            ).toLocaleString()}
                            <span className="text-[10px] ml-1 uppercase">{currency}</span>
                        </span>
                    </div>
                </div>
            </div>
          )}
          {activeTab === 'Safety' && (
            <div className="max-w-7xl mx-auto space-y-6 animate-in slide-in-from-right duration-500 pb-20">
              
              {/* 1. Hazards & Precautions Section */}
              <Section title={t('wo.safety.hazardsTitle')}>
                <div className="bg-white border rounded shadow-sm overflow-hidden">
                  <table className={`w-full ${isRTL ? 'text-right' : 'text-left'}`}>
                    <thead className="bg-[#f8fafc] border-b text-gray-700 text-[0.9] font-black uppercase">
                      <tr>
                        <th className="p-3 border-r w-40">{t('wo.safety.hazardCode')}</th>
                        <th className="p-3 border-r">{t('wo.safety.hazardDesc')}</th>
                        <th className="p-3">{t('wo.safety.precautions')}</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {data.wohazards?.length > 0 ? (
                        data.wohazards.map((h, i) => (
                          <tr key={i} className="hover:bg-red-50/30 transition-colors">
                            <td className="p-3 border-r font-black text-red-700 align-top flex items-center gap-2">
                              <AlertTriangle size={14} className="text-red-600" /> {h.hazardnum}
                            </td>
                            <td className="p-3 border-r font-semibold text-gray-600 align-top uppercase italic">
                              {h.description}
                            </td>
                            <td className="p-0 align-top">
                              {/* عرض الاحتياطات المربوطة بهذا الخطر بالذات */}
                              <table className="w-full bg-slate-50/50">
                                <tbody>
                                  {h.precautions?.map((p, pi) => (
                                    <tr key={pi} className="border-b last:border-0 border-slate-100">
                                      <td className="p-2 flex items-start gap-2">
                                        <div className="mt-1"><CheckCircle size={12} className="text-green-600" /></div>
                                        <div>
                                          <span className="font-black text-blue-900 text-[0.8] mr-2">{p.precautionnum}</span>
                                          <span className="text-gray-600 font-bold uppercase">{p.description}</span>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="p-10 text-center text-gray-300 italic">
                            {t('wo.safety.noHazards')}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Section>

              {/* 2. Lock Out / Tag Out Section */}
              <Section title={t('wo.safety.lotoTitle')}>
                <div className="bg-white border rounded shadow-sm overflow-hidden">
                  <table className="w-full text-left">
                    <thead className="bg-[#f8fafc] border-b text-gray-700 text-[0.9] font-black uppercase tracking-tighter">
                      <tr>
                        <th className="p-3 border-r w-20 text-center">{t('wo.safety.step')}</th>
                        <th className="p-3 border-r w-40">{t('wo.safety.tagNum')}</th>
                        <th className="p-3 border-r">{t('wo.safety.isoDesc')}</th>
                        <th className="p-3 border-r w-32 text-center">{t('wo.safety.reqState')}</th>
                        <th className="p-3 w-32 text-center">{t('wo.safety.completed')}</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y">
                      {data.woloto?.length > 0 ? (
                        data.woloto.map((t, i) => (
                          <tr key={i} className="hover:bg-blue-50/30 transition-colors font-bold uppercase">
                            <td className="p-3 border-r text-center text-slate-400 font-black">{t.sequence || i+1}</td>
                            <td className="p-3 border-r font-black text-blue-900">{t.tagoutnum}</td>
                            <td className="p-3 border-r text-gray-600">{t.description}</td>
                            <td className="p-3 border-r text-center">
                              <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-[0.8] font-black">
                                {t.required_state || 'LOCKED/OFF'}
                              </span>
                            </td>
                            <td className="p-3 text-center">
                              {/* هنا ممكن الفني يعلم إنه خلص خطوة العزل فعلياً */}
                              <input type="checkbox" className="w-4 h-4 accent-green-600" />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="p-10 text-center text-gray-300 italic">
                            {t('wo.safety.noLoto')}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Section>

              {/* 3. Hazardous Materials Section (Optional but Professional) */}
              <Section title="Hazardous Materials Information">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {data.wohazards_materials?.length > 0 ? (
                      data.wohazards_materials.map((m, i) => (
                        <div key={i} className="flex items-center gap-4 p-4 border rounded-sm bg-orange-50/50 border-orange-100">
                          <div className="p-3 bg-orange-600 text-white rounded-sm"><Zap size={20}/></div>
                          <div className="flex flex-col">
                            <span className="font-black text-orange-900">{m.itemnum}</span>
                            <span className="text-[10px] text-orange-700 font-bold uppercase">{m.description}</span>
                            <span className="text-[9px] mt-1 text-gray-500 italic">Precautions: {m.special_precautions || 'Follow Standard SDS'}</span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-span-2 p-6 text-center text-gray-300 border-2 border-dashed rounded italic">
                        No hazardous materials associated with this task.
                      </div>
                    )}
                </div>
              </Section>
            </div>
          )}     
          {activeTab === 'Failure Reporting' && (
            <div className="max-w-7xl mx-auto space-y-8 animate-in fade-in duration-500 pb-20">
              
              {/* الهيدر التعريفي */}
              <div className="bg-blue-900 text-white p-4 rounded-sm flex justify-between items-center shadow-lg">
                <div className="flex items-center gap-4">
                  <BrainCircuit size={28} className="text-orange-400" />
                  <div>
                    <h3 className="font-black uppercase text-sm tracking-widest">{t('wo.failure.title')}</h3>
                    <p className="text-[0.9] opacity-70">{t('wo.failure.currClass')}: <span className="text-orange-400 font-black">{data.failure_class || 'NOT DEFINED'}</span></p>
                  </div>
                </div>
              </div>

              {/* 1. PROBLEMS TABLE */}
              <FailureTable 
                title={t('wo.failure.problems')} 
                data={data.wofailure.filter(f => f.failure_type === 'PROBLEM')} 
                onAdd={() => addFailureRow('PROBLEM')}
                onSearch={(idx) => handleSmartSearch('failure_code', 'Select Problem', 'LOCAL_LIST', (row) => {
                    updateFailureRow(idx, 'failure_code', row.code, row.description);
                }, failureLists.problems)}
              />

              {/* 2. CAUSES TABLE */}
              <FailureTable 
                title={t('wo.failure.causes')} 
                data={data.wofailure.filter(f => f.failure_type === 'CAUSE')} 
                onAdd={() => addFailureRow('CAUSE')}
                onSearch={(idx) => handleSmartSearch('failure_code', 'Select Cause', 'LOCAL_LIST', (row) => {
                    updateFailureRow(idx, 'failure_code', row.code, row.description);
                }, failureLists.causes)}
              />

              {/* 3. REMEDIES TABLE */}
              <FailureTable 
                title={t('wo.failure.remedies')} 
                data={data.wofailure.filter(f => f.failure_type === 'REMEDY')} 
                onAdd={() => addFailureRow('REMEDY')}
                onSearch={(idx) => handleSmartSearch('failure_code', 'Select Remedy', 'LOCAL_LIST', (row) => {
                    updateFailureRow(idx, 'failure_code', row.code, row.description);
                }, failureLists.remedies)}
              />
            </div>
          )}    
      </div>
    </div>
  );
};

// --- Reusable UI Components ---
const formatDateTime = (dateString) => {
    if (!dateString) return '';
    return dateString.split('.')[0].substring(0, 16);
  };
const Section = ({ title, children }) => (
  <div className="bg-white border rounded shadow-sm">
    <div className="p-2 bg-slate-50 border-b font-bold text-slate-500 uppercase text-[0.8] tracking-widest flex items-center gap-2">
      <div className="w-1.5 h-3 bg-blue-600 rounded-full"></div> {title}
    </div>
    <div className="p-5">{children}</div>
  </div>
);

const DataField = ({ label, value, desc, onSearch, onMouseEnter, onMouseLeave }) => (
  <div className="flex flex-col border-b border-gray-100 py-2 group hover:bg-blue-50/20 transition-all px-1">
    <label className="text-[0.8] font-black text-gray-700 uppercase tracking-tighter">{label}</label>
    <div className="flex justify-between items-center h-5 mt-1">
      <div className="flex gap-4 items-center">
        {/* ?? ??????? ???: ????? ??? Events ??? span */}
        <span 
          className={`font-black text-blue-900 uppercase ${onMouseEnter ? 'cursor-help hover:text-blue-600' : ''}`}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          {value || '---'}
        </span>
        {desc && <span className="text-gray-700 font-normal italic text-[10px]">{desc}</span>}
      </div>
      {onSearch && <Search size={13} className="text-blue-400 cursor-pointer hover:text-blue-800 transition-colors" onClick={onSearch} />}
    </div>
  </div>
);

const DateField = ({ label, value, onChange, hasCalendar, readOnly }) => (
  <div className="flex flex-col border-b border-gray-300 py-1 group focus-within:border-blue-500 transition-all">
    <div className="flex justify-between items-center">
       <label className="text-[0.8] font-black text-gray-700 uppercase tracking-tighter">{label}</label>
       {hasCalendar && <Calendar size={14} className="text-blue-600 opacity-0 group-hover:opacity-100 transition-all cursor-pointer"/>}
    </div>
    <input 
      type="datetime-local" 
      readOnly={readOnly}
      // إضافة CSS كلاس عشان اليوزر يعرف إن الحقل مقفول
      className={`outline-none font-bold py-0.5 text-[0.8] bg-transparent ${readOnly ? 'text-gray-500 cursor-not-allowed' : 'text-blue-900'}`} 
      // ?? ??????? ????? ??? ??? ?? ???? ??? input
      value={formatDateTime(value)} 
      onChange={e => !readOnly && onChange(e.target.value)} 
    />
  </div>
);

const EditableField2 = ({ label, value, onChange, onSearch, isRequired, hasList, hasCalendar, desc, type = "text" }) => (
  <div className="flex flex-col gap-1 border-b border-gray-300 group">
    <label className={`${isRequired ? 'text-red-800' : 'text-gray-700'} font-bold text-[0.8] uppercase tracking-tighter`}>{label}</label>
    <div className="flex items-center justify-between pb-1">
      <input 
        type={type} // <--- ????? ?? ???? ?????? ????? (text, datetime-local, number, etc.)
        className="outline-none font-bold text-blue-900 bg-transparent w-full custom-datetime-input" 
        value={value || ''} 
        onChange={e => onChange && onChange(e.target.value)} 
      />
      {desc && <span className="text-gray-700 font-normal px-4 italic whitespace-nowrap">{desc}</span>}
      <div className="flex gap-2 text-blue-700 cursor-pointer">
        {hasList && <List size={14}/>}
        {hasCalendar && <Calendar size={14}/>}
        {onSearch && <Search size={13} className="text-blue-400 cursor-pointer hover:text-blue-800 transition-colors" onClick={onSearch} />}
      </div>
    </div>
  </div>
);
const EditableField = ({ label, value, onChange, onSearch, isRequired, lookupType, hasList, hasCalendar, desc, type = "text" }) => {
  const [description, setDesc] = useState("");
  // 🎯 استيت محلي عشان اليوزر يكتب براحته بدون تدخل التنسيق المالي أثناء الكتابة
  const [inputValue, setInputValue] = useState(value || "");

  // تحديث الاستيت المحلي لو الـ value اللي جاية من بره اتغيرت (عشان الـ Load)
  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  // منطق جلب الوصف (Lookup Description)
  useEffect(() => {
    if (value && lookupType) {
      const fetchDesc = async () => {
        try {
          const res = await axios.get(`/api/lookup-desc/resolve?type=${lookupType}&code=${value}`);
          setDesc(res.data.description || "");
        } catch (err) { setDesc(""); }
      };
      fetchDesc();
    } else { setDesc(""); }
  }, [value, lookupType]);

  // دالة التنسيق المالي (بتشتغل فقط عند العرض)
  const formatCurrency = (val) => {
    if (val === "" || val === null || isNaN(val)) return val;
    return Number(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // هل الحقل ده مالي؟ (Price أو Cost)
  const isNumericField = label.toLowerCase().includes("price") || label.toLowerCase().includes("cost") || label.toLowerCase().includes("rate");

  return (
    <div className="flex flex-col gap-1 border-b border-gray-300 group mb-2">
      <label className={`${isRequired ? 'text-red-800' : 'text-gray-400'} font-bold text-[0.9] uppercase tracking-tighter`}>
        {label}
      </label>
      
      <div className="flex items-center justify-between pb-0.5">
        <input 
          type={type === "datetime-local" ? "datetime-local" : "text"} 
          className="outline-none font-black text-blue-900 bg-transparent w-full text-xs" 
          // 🎯 لو حقل مالي، اعرض القيمة الخام أثناء الكتابة، والمعادلة (الفواصل) وأنت بره
          value={type === "datetime-local" && inputValue ? inputValue.substring(0, 16).replace(' ', 'T') : inputValue}
          
          onChange={e => {
            let val = e.target.value;
            if (isNumericField) {
              // السماح فقط بالأرقام والنقطة العشرية (تنظيف أي فواصل جاية بالغط)
              val = val.replace(/,/g, '');
              if (val !== "" && isNaN(val) && val !== ".") return;
            }
            setInputValue(val); // تحديث المنظر قدام اليوزر فوراً
            if (!isNumericField) onChange(val); // لو مش مالي سيف فوراً
          }}

          onBlur={() => {
            // 🎯 لما اليوزر يخرج من الخانة، نبعت القيمة النهائية للـ Parent وننظفها
            if (isNumericField) {
              const cleanVal = String(inputValue).replace(/,/g, '');
              onChange(cleanVal);
              // نحول المنظر للفواصل بعد الخروج
              setInputValue(formatCurrency(cleanVal));
            }
          }}

          onFocus={() => {
            // 🎯 لما يرجع يضغط، نشيل الفواصل عشان يعرف يمسح ويعدل بسهولة
            if (isNumericField) {
              setInputValue(String(inputValue).replace(/,/g, ''));
            }
          }}
        />
        
        <div className="flex gap-2 text-blue-700 cursor-pointer shrink-0">
          {hasList && <List size={14}/>}
          {hasCalendar && <Calendar size={14}/>}
          {onSearch && <Search size={13} className="text-blue-400 hover:text-blue-800 transition-colors" onClick={onSearch} />}
        </div>
      </div>

      {(description || desc) && (
        <div className="text-[10px] text-orange-600 font-bold italic animate-in fade-in slide-in-from-left-1 leading-none pb-1">
          {description || desc}
        </div>
      )}
    </div>
  );
};

const Table = ({ columns, data, isActual }) => (
  <div className="border rounded-sm overflow-hidden">
    <table className="w-full text-left">
      <thead className={`bg-gray-50 border-b text-[0.9] font-black uppercase text-gray-700`}>
        <tr>
          {columns.map(col => <th key={col} className="p-2 border-r">{col}</th>)}
          <th className="p-2 w-8"></th>
        </tr>
      </thead>
      <tbody>
        {data?.length === 0 ? (
          <tr><td colSpan={columns.length + 1} className="p-8 text-center text-gray-300 italic">No records to display</td></tr>
        ) : data.map((row, i) => (
          <tr key={i} className="border-b text-[10px] hover:bg-blue-50 transition-colors">
            {Object.values(row).slice(1, columns.length + 1).map((val, j) => <td key={j} className="p-2 border-r font-bold text-blue-800">{val}</td>)}
            <td className="p-2 text-center"><Trash2 size={12} className="text-gray-300 hover:text-red-500 cursor-pointer"/></td>
          </tr>
        ))}
      </tbody>
    </table>
    <button className={`m-2 px-4 py-1.5 rounded-sm text-[9px] font-bold flex items-center gap-2 text-white shadow-sm ${isActual ? 'bg-green-600' : 'bg-blue-600'}`}>
      <Plus size={12}/> New Row
    </button>
  </div>
);

const FailureTable = ({ title, data, onAdd, onSearch, onRemove }) => {
  const { t } = useTranslation();
  return (
  <div className="bg-white border rounded shadow-sm overflow-hidden">
    <div className="p-3 bg-slate-50 border-b flex justify-between items-center">
      <h4 className="text-[0.9] font-black text-slate-600 uppercase tracking-tighter flex items-center gap-2">
        <Filter size={14} className="text-blue-500" /> {title}
      </h4>
      <span className="text-[0.8] bg-slate-200 px-2 py-0.5 rounded-full font-bold">{data.length} {t('wo.failure.records')}</span>
    </div>
    <table className="w-full text-left border-collapse">
      <thead className="bg-[#f8fafc] text-gray-400 font-bold text-[9px] uppercase border-b">
        <tr>
          <th className="p-3 border-r w-48">{t('wo.tables.failCode')}</th>
          <th className="p-3 border-r">{t('wo.tables.description')}</th>
          <th className="p-3 w-10 text-center"></th>
        </tr>
      </thead>
      <tbody className="divide-y text-[11px]">
        {data.map((row, i) => (
          <tr key={i} className="hover:bg-blue-50/30 transition-all">
            <td className="p-3 border-r font-black text-blue-900 flex justify-between items-center group">
              {row.failure_code || '---'}
              <Search size={14} className="text-blue-400 cursor-pointer hover:text-blue-700" onClick={() => onSearch(i)} />
            </td>
            <td className="p-3 border-r text-gray-500 italic">{row.description}</td>
            <td className="p-3 text-center">
              <button onClick={() => onRemove(i)} className="text-gray-300 hover:text-red-500"><Trash2 size={14}/></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    <button onClick={onAdd} className="m-3 bg-[#3c70a4] text-white px-6 py-1.5 rounded-sm font-black text-[10px] flex items-center gap-2 hover:bg-black transition-all shadow-md uppercase">
      <Plus size={14} /> {t('common.new_row')}
    </button>
  </div>
)}; 

export default WorkOrderDetails;